var _o = Object.defineProperty;
var Jn = (e) => {
  throw TypeError(e);
};
var bo = (e, t, r) => t in e ? _o(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var ne = (e, t, r) => bo(e, typeof t != "symbol" ? t + "" : t, r), zn = (e, t, r) => t.has(e) || Jn("Cannot " + r);
var g = (e, t, r) => (zn(e, t, "read from private field"), r ? r.call(e) : t.get(e)), pe = (e, t, r) => t.has(e) ? Jn("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), ye = (e, t, r, n) => (zn(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
var So = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
};
function Ao(e) {
  return e;
}
function _e(e, t, r, n, a, s, i, o, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return function() {
        return t(e.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(t(e.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(t(e.apply(this, arguments))));
      };
    case 5:
      return function() {
        return a(n(r(t(e.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return s(a(n(r(t(e.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return i(s(a(n(r(t(e.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return o(i(s(a(n(r(t(e.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return u(o(i(s(a(n(r(t(e.apply(this, arguments)))))))));
      };
  }
}
function _(e, t, r, n, a, s, i, o, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return r(t(e));
    case 4:
      return n(r(t(e)));
    case 5:
      return a(n(r(t(e))));
    case 6:
      return s(a(n(r(t(e)))));
    case 7:
      return i(s(a(n(r(t(e))))));
    case 8:
      return o(i(s(a(n(r(t(e)))))));
    case 9:
      return u(o(i(s(a(n(r(t(e))))))));
    default: {
      for (var d = arguments[0], y = 1; y < arguments.length; y++)
        d = arguments[y](d);
      return d;
    }
  }
}
var To = function(e, t) {
  var r = function(n) {
    return n.length >= e;
  };
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? t.apply(this, n) : function(a) {
      return t.apply(void 0, So([a], n, !1));
    };
  };
}, $o = function(e) {
  return {
    equals: function(t, r) {
      return t === r || e(t, r);
    }
  };
}, Eo = function(e) {
  return $o(function(t, r) {
    for (var n in e)
      if (!e[n].equals(t[n], r[n]))
        return !1;
    return !0;
  });
}, za = function(e) {
  return e._tag === "Some";
}, Qa = { _tag: "None" }, Ya = function(e) {
  return { _tag: "Some", value: e };
}, wo = function(e) {
  return e._tag === "Left";
}, Ro = function(e) {
  return e._tag === "Right";
}, xo = function(e) {
  return { _tag: "Left", left: e };
}, Co = function(e) {
  return { _tag: "Right", right: e };
}, Oo = function(e) {
  return [e];
}, ko = [], Io = Object.prototype.hasOwnProperty, Po = function(e) {
  return function(t) {
    return function(r) {
      return r.reduce(function(n, a) {
        return e.concat(n, a);
      }, t);
    };
  };
}, No = function(e) {
  return {
    concat: function(t, r) {
      var n = {};
      for (var a in e)
        Io.call(e, a) && (n[a] = e[a].concat(t[a], r[a]));
      return n;
    }
  };
}, jr = function() {
  return { concat: Ao };
}, Mo = function() {
  return { concat: function(e, t) {
    return t;
  } };
}, jo = Po, Qn = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Vo = ko, Ho = function(e, t) {
  return e < 0 || e >= t.length;
}, Do = function(e) {
  return function(t) {
    return Qn(Qn([], t, !0), [e], !1);
  };
}, Lo = Do, Uo = Oo, me = {
  equals: function(e, t) {
    return e === t;
  }
}, qo = {
  concat: function(e, t) {
    return e + t;
  }
}, Ko = "", dn = {
  concat: qo.concat,
  empty: Ko
};
me.equals;
var Xa = function(e) {
  return e.trim();
}, es = function(e) {
  return e.length === 0;
}, Pt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ts(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Bo() {
  this.__data__ = [], this.size = 0;
}
var Zo = Bo;
function Wo(e, t) {
  return e === t || e !== e && t !== t;
}
var fn = Wo, Fo = fn;
function Go(e, t) {
  for (var r = e.length; r--; )
    if (Fo(e[r][0], t))
      return r;
  return -1;
}
var ir = Go, Jo = ir, zo = Array.prototype, Qo = zo.splice;
function Yo(e) {
  var t = this.__data__, r = Jo(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Qo.call(t, r, 1), --this.size, !0;
}
var Xo = Yo, ec = ir;
function tc(e) {
  var t = this.__data__, r = ec(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var rc = tc, nc = ir;
function ac(e) {
  return nc(this.__data__, e) > -1;
}
var sc = ac, ic = ir;
function oc(e, t) {
  var r = this.__data__, n = ic(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var cc = oc, uc = Zo, lc = Xo, dc = rc, fc = sc, hc = cc;
function rt(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
rt.prototype.clear = uc;
rt.prototype.delete = lc;
rt.prototype.get = dc;
rt.prototype.has = fc;
rt.prototype.set = hc;
var or = rt, pc = or;
function yc() {
  this.__data__ = new pc(), this.size = 0;
}
var mc = yc;
function vc(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var gc = vc;
function _c(e) {
  return this.__data__.get(e);
}
var bc = _c;
function Sc(e) {
  return this.__data__.has(e);
}
var Ac = Sc, Tc = typeof Pt == "object" && Pt && Pt.Object === Object && Pt, rs = Tc, $c = rs, Ec = typeof self == "object" && self && self.Object === Object && self, wc = $c || Ec || Function("return this")(), te = wc, Rc = te, xc = Rc.Symbol, cr = xc, Yn = cr, ns = Object.prototype, Cc = ns.hasOwnProperty, Oc = ns.toString, ut = Yn ? Yn.toStringTag : void 0;
function kc(e) {
  var t = Cc.call(e, ut), r = e[ut];
  try {
    e[ut] = void 0;
    var n = !0;
  } catch {
  }
  var a = Oc.call(e);
  return n && (t ? e[ut] = r : delete e[ut]), a;
}
var Ic = kc, Pc = Object.prototype, Nc = Pc.toString;
function Mc(e) {
  return Nc.call(e);
}
var jc = Mc, Xn = cr, Vc = Ic, Hc = jc, Dc = "[object Null]", Lc = "[object Undefined]", ea = Xn ? Xn.toStringTag : void 0;
function Uc(e) {
  return e == null ? e === void 0 ? Lc : Dc : ea && ea in Object(e) ? Vc(e) : Hc(e);
}
var ur = Uc;
function qc(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var gt = qc, Kc = ur, Bc = gt, Zc = "[object AsyncFunction]", Wc = "[object Function]", Fc = "[object GeneratorFunction]", Gc = "[object Proxy]";
function Jc(e) {
  if (!Bc(e))
    return !1;
  var t = Kc(e);
  return t == Wc || t == Fc || t == Zc || t == Gc;
}
var as = Jc, zc = te, Qc = zc["__core-js_shared__"], Yc = Qc, Vr = Yc, ta = function() {
  var e = /[^.]+$/.exec(Vr && Vr.keys && Vr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Xc(e) {
  return !!ta && ta in e;
}
var eu = Xc, tu = Function.prototype, ru = tu.toString;
function nu(e) {
  if (e != null) {
    try {
      return ru.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ss = nu, au = as, su = eu, iu = gt, ou = ss, cu = /[\\^$.*+?()[\]{}|]/g, uu = /^\[object .+?Constructor\]$/, lu = Function.prototype, du = Object.prototype, fu = lu.toString, hu = du.hasOwnProperty, pu = RegExp(
  "^" + fu.call(hu).replace(cu, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function yu(e) {
  if (!iu(e) || su(e))
    return !1;
  var t = au(e) ? pu : uu;
  return t.test(ou(e));
}
var mu = yu;
function vu(e, t) {
  return e == null ? void 0 : e[t];
}
var gu = vu, _u = mu, bu = gu;
function Su(e, t) {
  var r = bu(e, t);
  return _u(r) ? r : void 0;
}
var Ie = Su, Au = Ie, Tu = te, $u = Au(Tu, "Map"), hn = $u, Eu = Ie, wu = Eu(Object, "create"), lr = wu, ra = lr;
function Ru() {
  this.__data__ = ra ? ra(null) : {}, this.size = 0;
}
var xu = Ru;
function Cu(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ou = Cu, ku = lr, Iu = "__lodash_hash_undefined__", Pu = Object.prototype, Nu = Pu.hasOwnProperty;
function Mu(e) {
  var t = this.__data__;
  if (ku) {
    var r = t[e];
    return r === Iu ? void 0 : r;
  }
  return Nu.call(t, e) ? t[e] : void 0;
}
var ju = Mu, Vu = lr, Hu = Object.prototype, Du = Hu.hasOwnProperty;
function Lu(e) {
  var t = this.__data__;
  return Vu ? t[e] !== void 0 : Du.call(t, e);
}
var Uu = Lu, qu = lr, Ku = "__lodash_hash_undefined__";
function Bu(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = qu && t === void 0 ? Ku : t, this;
}
var Zu = Bu, Wu = xu, Fu = Ou, Gu = ju, Ju = Uu, zu = Zu;
function nt(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
nt.prototype.clear = Wu;
nt.prototype.delete = Fu;
nt.prototype.get = Gu;
nt.prototype.has = Ju;
nt.prototype.set = zu;
var Qu = nt, na = Qu, Yu = or, Xu = hn;
function el() {
  this.size = 0, this.__data__ = {
    hash: new na(),
    map: new (Xu || Yu)(),
    string: new na()
  };
}
var tl = el;
function rl(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var nl = rl, al = nl;
function sl(e, t) {
  var r = e.__data__;
  return al(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var dr = sl, il = dr;
function ol(e) {
  var t = il(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var cl = ol, ul = dr;
function ll(e) {
  return ul(this, e).get(e);
}
var dl = ll, fl = dr;
function hl(e) {
  return fl(this, e).has(e);
}
var pl = hl, yl = dr;
function ml(e, t) {
  var r = yl(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var vl = ml, gl = tl, _l = cl, bl = dl, Sl = pl, Al = vl;
function at(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
at.prototype.clear = gl;
at.prototype.delete = _l;
at.prototype.get = bl;
at.prototype.has = Sl;
at.prototype.set = Al;
var is = at, Tl = or, $l = hn, El = is, wl = 200;
function Rl(e, t) {
  var r = this.__data__;
  if (r instanceof Tl) {
    var n = r.__data__;
    if (!$l || n.length < wl - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new El(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var xl = Rl, Cl = or, Ol = mc, kl = gc, Il = bc, Pl = Ac, Nl = xl;
function st(e) {
  var t = this.__data__ = new Cl(e);
  this.size = t.size;
}
st.prototype.clear = Ol;
st.prototype.delete = kl;
st.prototype.get = Il;
st.prototype.has = Pl;
st.prototype.set = Nl;
var os = st;
function Ml(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var jl = Ml, Vl = Ie, Hl = function() {
  try {
    var e = Vl(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Dl = Hl, aa = Dl;
function Ll(e, t, r) {
  t == "__proto__" && aa ? aa(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var cs = Ll, Ul = cs, ql = fn, Kl = Object.prototype, Bl = Kl.hasOwnProperty;
function Zl(e, t, r) {
  var n = e[t];
  (!(Bl.call(e, t) && ql(n, r)) || r === void 0 && !(t in e)) && Ul(e, t, r);
}
var us = Zl, Wl = us, Fl = cs;
function Gl(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var s = -1, i = t.length; ++s < i; ) {
    var o = t[s], u = n ? n(r[o], e[o], o, r, e) : void 0;
    u === void 0 && (u = e[o]), a ? Fl(r, o, u) : Wl(r, o, u);
  }
  return r;
}
var fr = Gl;
function Jl(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var zl = Jl;
function Ql(e) {
  return e != null && typeof e == "object";
}
var it = Ql, Yl = ur, Xl = it, ed = "[object Arguments]";
function td(e) {
  return Xl(e) && Yl(e) == ed;
}
var rd = td, sa = rd, nd = it, ls = Object.prototype, ad = ls.hasOwnProperty, sd = ls.propertyIsEnumerable, id = sa(/* @__PURE__ */ function() {
  return arguments;
}()) ? sa : function(e) {
  return nd(e) && ad.call(e, "callee") && !sd.call(e, "callee");
}, od = id, cd = Array.isArray, hr = cd, Vt = { exports: {} };
function ud() {
  return !1;
}
var ld = ud;
Vt.exports;
(function(e, t) {
  var r = te, n = ld, a = t && !t.nodeType && t, s = a && !0 && e && !e.nodeType && e, i = s && s.exports === a, o = i ? r.Buffer : void 0, u = o ? o.isBuffer : void 0, d = u || n;
  e.exports = d;
})(Vt, Vt.exports);
var pn = Vt.exports, dd = 9007199254740991, fd = /^(?:0|[1-9]\d*)$/;
function hd(e, t) {
  var r = typeof e;
  return t = t ?? dd, !!t && (r == "number" || r != "symbol" && fd.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var pd = hd, yd = 9007199254740991;
function md(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= yd;
}
var ds = md, vd = ur, gd = ds, _d = it, bd = "[object Arguments]", Sd = "[object Array]", Ad = "[object Boolean]", Td = "[object Date]", $d = "[object Error]", Ed = "[object Function]", wd = "[object Map]", Rd = "[object Number]", xd = "[object Object]", Cd = "[object RegExp]", Od = "[object Set]", kd = "[object String]", Id = "[object WeakMap]", Pd = "[object ArrayBuffer]", Nd = "[object DataView]", Md = "[object Float32Array]", jd = "[object Float64Array]", Vd = "[object Int8Array]", Hd = "[object Int16Array]", Dd = "[object Int32Array]", Ld = "[object Uint8Array]", Ud = "[object Uint8ClampedArray]", qd = "[object Uint16Array]", Kd = "[object Uint32Array]", k = {};
k[Md] = k[jd] = k[Vd] = k[Hd] = k[Dd] = k[Ld] = k[Ud] = k[qd] = k[Kd] = !0;
k[bd] = k[Sd] = k[Pd] = k[Ad] = k[Nd] = k[Td] = k[$d] = k[Ed] = k[wd] = k[Rd] = k[xd] = k[Cd] = k[Od] = k[kd] = k[Id] = !1;
function Bd(e) {
  return _d(e) && gd(e.length) && !!k[vd(e)];
}
var Zd = Bd;
function Wd(e) {
  return function(t) {
    return e(t);
  };
}
var yn = Wd, Ht = { exports: {} };
Ht.exports;
(function(e, t) {
  var r = rs, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s && r.process, o = function() {
    try {
      var u = a && a.require && a.require("util").types;
      return u || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = o;
})(Ht, Ht.exports);
var mn = Ht.exports, Fd = Zd, Gd = yn, ia = mn, oa = ia && ia.isTypedArray, Jd = oa ? Gd(oa) : Fd, fs = Jd, zd = zl, Qd = od, Yd = hr, Xd = pn, ef = pd, tf = fs, rf = Object.prototype, nf = rf.hasOwnProperty;
function af(e, t) {
  var r = Yd(e), n = !r && Qd(e), a = !r && !n && Xd(e), s = !r && !n && !a && tf(e), i = r || n || a || s, o = i ? zd(e.length, String) : [], u = o.length;
  for (var d in e)
    (t || nf.call(e, d)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    ef(d, u))) && o.push(d);
  return o;
}
var hs = af, sf = Object.prototype;
function of(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || sf;
  return e === r;
}
var vn = of;
function cf(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var ps = cf, uf = ps, lf = uf(Object.keys, Object), df = lf, ff = vn, hf = df, pf = Object.prototype, yf = pf.hasOwnProperty;
function mf(e) {
  if (!ff(e))
    return hf(e);
  var t = [];
  for (var r in Object(e))
    yf.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var vf = mf, gf = as, _f = ds;
function bf(e) {
  return e != null && _f(e.length) && !gf(e);
}
var ys = bf, Sf = hs, Af = vf, Tf = ys;
function $f(e) {
  return Tf(e) ? Sf(e) : Af(e);
}
var gn = $f, Ef = fr, wf = gn;
function Rf(e, t) {
  return e && Ef(t, wf(t), e);
}
var xf = Rf;
function Cf(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var Of = Cf, kf = gt, If = vn, Pf = Of, Nf = Object.prototype, Mf = Nf.hasOwnProperty;
function jf(e) {
  if (!kf(e))
    return Pf(e);
  var t = If(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !Mf.call(e, n)) || r.push(n);
  return r;
}
var Vf = jf, Hf = hs, Df = Vf, Lf = ys;
function Uf(e) {
  return Lf(e) ? Hf(e, !0) : Df(e);
}
var _n = Uf, qf = fr, Kf = _n;
function Bf(e, t) {
  return e && qf(t, Kf(t), e);
}
var Zf = Bf, Dt = { exports: {} };
Dt.exports;
(function(e, t) {
  var r = te, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s ? r.Buffer : void 0, o = i ? i.allocUnsafe : void 0;
  function u(d, y) {
    if (y)
      return d.slice();
    var A = d.length, $ = o ? o(A) : new d.constructor(A);
    return d.copy($), $;
  }
  e.exports = u;
})(Dt, Dt.exports);
var Wf = Dt.exports;
function Ff(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var Gf = Ff;
function Jf(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, s = []; ++r < n; ) {
    var i = e[r];
    t(i, r, e) && (s[a++] = i);
  }
  return s;
}
var zf = Jf;
function Qf() {
  return [];
}
var ms = Qf, Yf = zf, Xf = ms, eh = Object.prototype, th = eh.propertyIsEnumerable, ca = Object.getOwnPropertySymbols, rh = ca ? function(e) {
  return e == null ? [] : (e = Object(e), Yf(ca(e), function(t) {
    return th.call(e, t);
  }));
} : Xf, bn = rh, nh = fr, ah = bn;
function sh(e, t) {
  return nh(e, ah(e), t);
}
var ih = sh;
function oh(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var vs = oh, ch = ps, uh = ch(Object.getPrototypeOf, Object), gs = uh, lh = vs, dh = gs, fh = bn, hh = ms, ph = Object.getOwnPropertySymbols, yh = ph ? function(e) {
  for (var t = []; e; )
    lh(t, fh(e)), e = dh(e);
  return t;
} : hh, _s = yh, mh = fr, vh = _s;
function gh(e, t) {
  return mh(e, vh(e), t);
}
var _h = gh, bh = vs, Sh = hr;
function Ah(e, t, r) {
  var n = t(e);
  return Sh(e) ? n : bh(n, r(e));
}
var bs = Ah, Th = bs, $h = bn, Eh = gn;
function wh(e) {
  return Th(e, Eh, $h);
}
var Ss = wh, Rh = bs, xh = _s, Ch = _n;
function Oh(e) {
  return Rh(e, Ch, xh);
}
var kh = Oh, Ih = Ie, Ph = te, Nh = Ih(Ph, "DataView"), Mh = Nh, jh = Ie, Vh = te, Hh = jh(Vh, "Promise"), Dh = Hh, Lh = Ie, Uh = te, qh = Lh(Uh, "Set"), Kh = qh, Bh = Ie, Zh = te, Wh = Bh(Zh, "WeakMap"), Fh = Wh, Wr = Mh, Fr = hn, Gr = Dh, Jr = Kh, zr = Fh, As = ur, ot = ss, ua = "[object Map]", Gh = "[object Object]", la = "[object Promise]", da = "[object Set]", fa = "[object WeakMap]", ha = "[object DataView]", Jh = ot(Wr), zh = ot(Fr), Qh = ot(Gr), Yh = ot(Jr), Xh = ot(zr), Re = As;
(Wr && Re(new Wr(new ArrayBuffer(1))) != ha || Fr && Re(new Fr()) != ua || Gr && Re(Gr.resolve()) != la || Jr && Re(new Jr()) != da || zr && Re(new zr()) != fa) && (Re = function(e) {
  var t = As(e), r = t == Gh ? e.constructor : void 0, n = r ? ot(r) : "";
  if (n)
    switch (n) {
      case Jh:
        return ha;
      case zh:
        return ua;
      case Qh:
        return la;
      case Yh:
        return da;
      case Xh:
        return fa;
    }
  return t;
});
var pr = Re, ep = Object.prototype, tp = ep.hasOwnProperty;
function rp(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && tp.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var np = rp, ap = te, sp = ap.Uint8Array, Ts = sp, pa = Ts;
function ip(e) {
  var t = new e.constructor(e.byteLength);
  return new pa(t).set(new pa(e)), t;
}
var Sn = ip, op = Sn;
function cp(e, t) {
  var r = t ? op(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var up = cp, lp = /\w*$/;
function dp(e) {
  var t = new e.constructor(e.source, lp.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var fp = dp, ya = cr, ma = ya ? ya.prototype : void 0, va = ma ? ma.valueOf : void 0;
function hp(e) {
  return va ? Object(va.call(e)) : {};
}
var pp = hp, yp = Sn;
function mp(e, t) {
  var r = t ? yp(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var vp = mp, gp = Sn, _p = up, bp = fp, Sp = pp, Ap = vp, Tp = "[object Boolean]", $p = "[object Date]", Ep = "[object Map]", wp = "[object Number]", Rp = "[object RegExp]", xp = "[object Set]", Cp = "[object String]", Op = "[object Symbol]", kp = "[object ArrayBuffer]", Ip = "[object DataView]", Pp = "[object Float32Array]", Np = "[object Float64Array]", Mp = "[object Int8Array]", jp = "[object Int16Array]", Vp = "[object Int32Array]", Hp = "[object Uint8Array]", Dp = "[object Uint8ClampedArray]", Lp = "[object Uint16Array]", Up = "[object Uint32Array]";
function qp(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case kp:
      return gp(e);
    case Tp:
    case $p:
      return new n(+e);
    case Ip:
      return _p(e, r);
    case Pp:
    case Np:
    case Mp:
    case jp:
    case Vp:
    case Hp:
    case Dp:
    case Lp:
    case Up:
      return Ap(e, r);
    case Ep:
      return new n();
    case wp:
    case Cp:
      return new n(e);
    case Rp:
      return bp(e);
    case xp:
      return new n();
    case Op:
      return Sp(e);
  }
}
var Kp = qp, Bp = gt, ga = Object.create, Zp = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Bp(t))
      return {};
    if (ga)
      return ga(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), Wp = Zp, Fp = Wp, Gp = gs, Jp = vn;
function zp(e) {
  return typeof e.constructor == "function" && !Jp(e) ? Fp(Gp(e)) : {};
}
var Qp = zp, Yp = pr, Xp = it, ey = "[object Map]";
function ty(e) {
  return Xp(e) && Yp(e) == ey;
}
var ry = ty, ny = ry, ay = yn, _a = mn, ba = _a && _a.isMap, sy = ba ? ay(ba) : ny, iy = sy, oy = pr, cy = it, uy = "[object Set]";
function ly(e) {
  return cy(e) && oy(e) == uy;
}
var dy = ly, fy = dy, hy = yn, Sa = mn, Aa = Sa && Sa.isSet, py = Aa ? hy(Aa) : fy, yy = py, my = os, vy = jl, gy = us, _y = xf, by = Zf, Sy = Wf, Ay = Gf, Ty = ih, $y = _h, Ey = Ss, wy = kh, Ry = pr, xy = np, Cy = Kp, Oy = Qp, ky = hr, Iy = pn, Py = iy, Ny = gt, My = yy, jy = gn, Vy = _n, Hy = 1, Dy = 2, Ly = 4, $s = "[object Arguments]", Uy = "[object Array]", qy = "[object Boolean]", Ky = "[object Date]", By = "[object Error]", Es = "[object Function]", Zy = "[object GeneratorFunction]", Wy = "[object Map]", Fy = "[object Number]", ws = "[object Object]", Gy = "[object RegExp]", Jy = "[object Set]", zy = "[object String]", Qy = "[object Symbol]", Yy = "[object WeakMap]", Xy = "[object ArrayBuffer]", em = "[object DataView]", tm = "[object Float32Array]", rm = "[object Float64Array]", nm = "[object Int8Array]", am = "[object Int16Array]", sm = "[object Int32Array]", im = "[object Uint8Array]", om = "[object Uint8ClampedArray]", cm = "[object Uint16Array]", um = "[object Uint32Array]", O = {};
O[$s] = O[Uy] = O[Xy] = O[em] = O[qy] = O[Ky] = O[tm] = O[rm] = O[nm] = O[am] = O[sm] = O[Wy] = O[Fy] = O[ws] = O[Gy] = O[Jy] = O[zy] = O[Qy] = O[im] = O[om] = O[cm] = O[um] = !0;
O[By] = O[Es] = O[Yy] = !1;
function jt(e, t, r, n, a, s) {
  var i, o = t & Hy, u = t & Dy, d = t & Ly;
  if (r && (i = a ? r(e, n, a, s) : r(e)), i !== void 0)
    return i;
  if (!Ny(e))
    return e;
  var y = ky(e);
  if (y) {
    if (i = xy(e), !o)
      return Ay(e, i);
  } else {
    var A = Ry(e), $ = A == Es || A == Zy;
    if (Iy(e))
      return Sy(e, o);
    if (A == ws || A == $s || $ && !a) {
      if (i = u || $ ? {} : Oy(e), !o)
        return u ? $y(e, by(i, e)) : Ty(e, _y(i, e));
    } else {
      if (!O[A])
        return a ? e : {};
      i = Cy(e, A, o);
    }
  }
  s || (s = new my());
  var B = s.get(e);
  if (B)
    return B;
  s.set(e, i), My(e) ? e.forEach(function(D) {
    i.add(jt(D, t, r, D, e, s));
  }) : Py(e) && e.forEach(function(D, q) {
    i.set(q, jt(D, t, r, q, e, s));
  });
  var U = d ? u ? wy : Ey : u ? Vy : jy, Z = y ? void 0 : U(e);
  return vy(Z || e, function(D, q) {
    Z && (q = D, D = e[q]), gy(i, q, jt(D, t, r, q, e, s));
  }), i;
}
var lm = jt, dm = lm, fm = 1, hm = 4;
function pm(e) {
  return dm(e, fm | hm);
}
var ym = pm;
const mm = /* @__PURE__ */ ts(ym);
var C;
(function(e) {
  e.assertEqual = (a) => {
  };
  function t(a) {
  }
  e.assertIs = t;
  function r(a) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), i = {};
    for (const o of s)
      i[o] = a[o];
    return e.objectValues(i);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, e.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(C || (C = {}));
var Ta;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(Ta || (Ta = {}));
const m = C.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ve = (e) => {
  switch (typeof e) {
    case "undefined":
      return m.undefined;
    case "string":
      return m.string;
    case "number":
      return Number.isNaN(e) ? m.nan : m.number;
    case "boolean":
      return m.boolean;
    case "function":
      return m.function;
    case "bigint":
      return m.bigint;
    case "symbol":
      return m.symbol;
    case "object":
      return Array.isArray(e) ? m.array : e === null ? m.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? m.promise : typeof Map < "u" && e instanceof Map ? m.map : typeof Set < "u" && e instanceof Set ? m.set : typeof Date < "u" && e instanceof Date ? m.date : m.object;
    default:
      return m.unknown;
  }
}, h = C.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class ce extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, u = 0;
          for (; u < i.path.length; ) {
            const d = i.path[u];
            u === i.path.length - 1 ? (o[d] = o[d] || { _errors: [] }, o[d]._errors.push(r(i))) : o[d] = o[d] || { _errors: [] }, o = o[d], u++;
          }
        }
    };
    return a(this), n;
  }
  static assert(t) {
    if (!(t instanceof ce))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, C.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
ce.create = (e) => new ce(e);
const Qr = (e, t) => {
  let r;
  switch (e.code) {
    case h.invalid_type:
      e.received === m.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case h.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, C.jsonStringifyReplacer)}`;
      break;
    case h.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${C.joinValues(e.keys, ", ")}`;
      break;
    case h.invalid_union:
      r = "Invalid input";
      break;
    case h.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${C.joinValues(e.options)}`;
      break;
    case h.invalid_enum_value:
      r = `Invalid enum value. Expected ${C.joinValues(e.options)}, received '${e.received}'`;
      break;
    case h.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case h.invalid_return_type:
      r = "Invalid function return type";
      break;
    case h.invalid_date:
      r = "Invalid date";
      break;
    case h.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : C.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case h.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case h.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case h.custom:
      r = "Invalid input";
      break;
    case h.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case h.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case h.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, C.assertNever(e);
  }
  return { message: r };
};
let vm = Qr;
function gm() {
  return vm;
}
const _m = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: a } = e, s = [...r, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const u = n.filter((d) => !!d).slice().reverse();
  for (const d of u)
    o = d(i, { data: t, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
};
function p(e, t) {
  const r = gm(), n = _m({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === Qr ? void 0 : Qr
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(n);
}
class K {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return S;
      a.status === "dirty" && t.dirty(), n.push(a.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const a of r) {
      const s = await a.key, i = await a.value;
      n.push({
        key: s,
        value: i
      });
    }
    return K.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return S;
      s.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (n[s.value] = i.value);
    }
    return { status: t.value, value: n };
  }
}
const S = Object.freeze({
  status: "aborted"
}), dt = (e) => ({ status: "dirty", value: e }), z = (e) => ({ status: "valid", value: e }), $a = (e) => e.status === "aborted", Ea = (e) => e.status === "dirty", Ge = (e) => e.status === "valid", Lt = (e) => typeof Promise < "u" && e instanceof Promise;
var v;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(v || (v = {}));
var Ut = function(e, t, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, Rs = function(e, t, r, n, a) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, ft, ht;
class X {
  constructor(t, r, n, a) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const wa = (e, t) => {
  if (Ge(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new ce(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function T(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: a } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (i, o) => {
    const { message: u } = e;
    return i.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: u ?? n ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: u ?? r ?? o.defaultError };
  }, description: a };
}
class w {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return ve(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: ve(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new K(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: ve(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (Lt(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    const n = {
      common: {
        issues: [],
        async: (r == null ? void 0 : r.async) ?? !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ve(t)
    }, a = this._parseSync({ data: t, path: n.path, parent: n });
    return wa(n, a);
  }
  "~validate"(t) {
    var n, a;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ve(t)
    };
    if (!this["~standard"].async)
      try {
        const s = this._parseSync({ data: t, path: [], parent: r });
        return Ge(s) ? {
          value: s.value
        } : {
          issues: r.common.issues
        };
      } catch (s) {
        (a = (n = s == null ? void 0 : s.message) == null ? void 0 : n.toLowerCase()) != null && a.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((s) => Ge(s) ? {
      value: s.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ve(t)
    }, a = this._parse({ data: t, path: n.path, parent: n }), s = await (Lt(a) ? a : Promise.resolve(a));
    return wa(n, s);
  }
  refine(t, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const i = t(a), o = () => s.addIssue({
        code: h.custom,
        ...n(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((u) => u ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, a) => t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(t) {
    return new ue({
      schema: this,
      typeName: b.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return oe.create(this, this._def);
  }
  nullable() {
    return ke.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Y.create(this);
  }
  promise() {
    return zt.create(this, this._def);
  }
  or(t) {
    return Bt.create([this, t], this._def);
  }
  and(t) {
    return Zt.create(this, t, this._def);
  }
  transform(t) {
    return new ue({
      ...T(this._def),
      schema: this,
      typeName: b.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Qt({
      ...T(this._def),
      innerType: this,
      defaultValue: r,
      typeName: b.ZodDefault
    });
  }
  brand() {
    return new ks({
      typeName: b.ZodBranded,
      type: this,
      ...T(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Yt({
      ...T(this._def),
      innerType: this,
      catchValue: r,
      typeName: b.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return Tn.create(this, t);
  }
  readonly() {
    return Xt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const bm = /^c[^\s-]{8,}$/i, Sm = /^[0-9a-z]+$/, Am = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Tm = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, $m = /^[a-z0-9_-]{21}$/i, Em = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, wm = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Rm = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, xm = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Hr;
const Cm = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Om = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, km = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Im = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Pm = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Nm = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, xs = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Mm = new RegExp(`^${xs}$`);
function Cs(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function jm(e) {
  return new RegExp(`^${Cs(e)}$`);
}
function Vm(e) {
  let t = `${xs}T${Cs(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function Hm(e, t) {
  return !!((t === "v4" || !t) && Cm.test(e) || (t === "v6" || !t) && km.test(e));
}
function Dm(e, t) {
  if (!Em.test(e))
    return !1;
  try {
    const [r] = e.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || "typ" in a && (a == null ? void 0 : a.typ) !== "JWT" || !a.alg || t && a.alg !== t);
  } catch {
    return !1;
  }
}
function Lm(e, t) {
  return !!((t === "v4" || !t) && Om.test(e) || (t === "v6" || !t) && Im.test(e));
}
class ie extends w {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== m.string) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_type,
        expected: m.string,
        received: s.parsedType
      }), S;
    }
    const n = new K();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (a = this._getOrReturnCtx(t, a), p(a, {
          code: h.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (a = this._getOrReturnCtx(t, a), p(a, {
          code: h.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const i = t.data.length > s.value, o = t.data.length < s.value;
        (i || o) && (a = this._getOrReturnCtx(t, a), i ? p(a, {
          code: h.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && p(a, {
          code: h.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        Rm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "email",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        Hr || (Hr = new RegExp(xm, "u")), Hr.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "emoji",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        Tm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "uuid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        $m.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "nanoid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        bm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "cuid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        Sm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "cuid2",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        Am.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "ulid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), p(a, {
            validation: "url",
            code: h.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "regex",
        code: h.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? Vm(s).test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? Mm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? jm(s).test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? wm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "duration",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? Hm(t.data, s.version) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "ip",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "jwt" ? Dm(t.data, s.alg) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "jwt",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "cidr" ? Lm(t.data, s.version) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "cidr",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? Pm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "base64",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64url" ? Nm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "base64url",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : C.assertNever(s);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((a) => t.test(a), {
      validation: r,
      code: h.invalid_string,
      ...v.errToObj(n)
    });
  }
  _addCheck(t) {
    return new ie({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...v.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...v.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...v.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...v.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...v.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...v.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...v.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...v.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...v.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...v.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...v.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...v.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...v.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (t == null ? void 0 : t.offset) ?? !1,
      local: (t == null ? void 0 : t.local) ?? !1,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...v.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...v.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...v.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...v.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...v.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...v.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, v.errToObj(t));
  }
  trim() {
    return new ie({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ie({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ie({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
ie.create = (e) => new ie({
  checks: [],
  typeName: b.ZodString,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...T(e)
});
function Um(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, a = r > n ? r : n, s = Number.parseInt(e.toFixed(a).replace(".", "")), i = Number.parseInt(t.toFixed(a).replace(".", ""));
  return s % i / 10 ** a;
}
class Je extends w {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== m.number) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_type,
        expected: m.number,
        received: s.parsedType
      }), S;
    }
    let n;
    const a = new K();
    for (const s of this._def.checks)
      s.kind === "int" ? C.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? Um(t.data, s.value) !== 0 && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.not_finite,
        message: s.message
      }), a.dirty()) : C.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, a) {
    return new Je({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Je({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: v.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: v.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: v.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: v.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && C.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
Je.create = (e) => new Je({
  checks: [],
  typeName: b.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...T(e)
});
class ze extends w {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== m.bigint)
      return this._getInvalidInput(t);
    let n;
    const a = new K();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : C.assertNever(s);
    return { status: a.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return p(r, {
      code: h.invalid_type,
      expected: m.bigint,
      received: r.parsedType
    }), S;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, a) {
    return new ze({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new ze({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
ze.create = (e) => new ze({
  checks: [],
  typeName: b.ZodBigInt,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...T(e)
});
class Yr extends w {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== m.boolean) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.boolean,
        received: n.parsedType
      }), S;
    }
    return z(t.data);
  }
}
Yr.create = (e) => new Yr({
  typeName: b.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...T(e)
});
class pt extends w {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== m.date) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_type,
        expected: m.date,
        received: s.parsedType
      }), S;
    }
    if (Number.isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_date
      }), S;
    }
    const n = new K();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : C.assertNever(s);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new pt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
pt.create = (e) => new pt({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: b.ZodDate,
  ...T(e)
});
class Xr extends w {
  _parse(t) {
    if (this._getType(t) !== m.symbol) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.symbol,
        received: n.parsedType
      }), S;
    }
    return z(t.data);
  }
}
Xr.create = (e) => new Xr({
  typeName: b.ZodSymbol,
  ...T(e)
});
class qt extends w {
  _parse(t) {
    if (this._getType(t) !== m.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.undefined,
        received: n.parsedType
      }), S;
    }
    return z(t.data);
  }
}
qt.create = (e) => new qt({
  typeName: b.ZodUndefined,
  ...T(e)
});
class Kt extends w {
  _parse(t) {
    if (this._getType(t) !== m.null) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.null,
        received: n.parsedType
      }), S;
    }
    return z(t.data);
  }
}
Kt.create = (e) => new Kt({
  typeName: b.ZodNull,
  ...T(e)
});
class yt extends w {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return z(t.data);
  }
}
yt.create = (e) => new yt({
  typeName: b.ZodAny,
  ...T(e)
});
class en extends w {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return z(t.data);
  }
}
en.create = (e) => new en({
  typeName: b.ZodUnknown,
  ...T(e)
});
class be extends w {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return p(r, {
      code: h.invalid_type,
      expected: m.never,
      received: r.parsedType
    }), S;
  }
}
be.create = (e) => new be({
  typeName: b.ZodNever,
  ...T(e)
});
class tn extends w {
  _parse(t) {
    if (this._getType(t) !== m.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.void,
        received: n.parsedType
      }), S;
    }
    return z(t.data);
  }
}
tn.create = (e) => new tn({
  typeName: b.ZodVoid,
  ...T(e)
});
class Y extends w {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), a = this._def;
    if (r.parsedType !== m.array)
      return p(r, {
        code: h.invalid_type,
        expected: m.array,
        received: r.parsedType
      }), S;
    if (a.exactLength !== null) {
      const i = r.data.length > a.exactLength.value, o = r.data.length < a.exactLength.value;
      (i || o) && (p(r, {
        code: i ? h.too_big : h.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (p(r, {
      code: h.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (p(r, {
      code: h.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => a.type._parseAsync(new X(r, i, r.path, o)))).then((i) => K.mergeArray(n, i));
    const s = [...r.data].map((i, o) => a.type._parseSync(new X(r, i, r.path, o)));
    return K.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new Y({
      ...this._def,
      minLength: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new Y({
      ...this._def,
      maxLength: { value: t, message: v.toString(r) }
    });
  }
  length(t, r) {
    return new Y({
      ...this._def,
      exactLength: { value: t, message: v.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Y.create = (e, t) => new Y({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: b.ZodArray,
  ...T(t)
});
function qe(e) {
  if (e instanceof N) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = oe.create(qe(n));
    }
    return new N({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof Y ? new Y({
    ...e._def,
    type: qe(e.element)
  }) : e instanceof oe ? oe.create(qe(e.unwrap())) : e instanceof ke ? ke.create(qe(e.unwrap())) : e instanceof Ce ? Ce.create(e.items.map((t) => qe(t))) : e;
}
class N extends w {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = C.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== m.object) {
      const d = this._getOrReturnCtx(t);
      return p(d, {
        code: h.invalid_type,
        expected: m.object,
        received: d.parsedType
      }), S;
    }
    const { status: n, ctx: a } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof be && this._def.unknownKeys === "strip"))
      for (const d in a.data)
        i.includes(d) || o.push(d);
    const u = [];
    for (const d of i) {
      const y = s[d], A = a.data[d];
      u.push({
        key: { status: "valid", value: d },
        value: y._parse(new X(a, A, a.path, d)),
        alwaysSet: d in a.data
      });
    }
    if (this._def.catchall instanceof be) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const y of o)
          u.push({
            key: { status: "valid", value: y },
            value: { status: "valid", value: a.data[y] }
          });
      else if (d === "strict")
        o.length > 0 && (p(a, {
          code: h.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (d !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const y of o) {
        const A = a.data[y];
        u.push({
          key: { status: "valid", value: y },
          value: d._parse(
            new X(a, A, a.path, y)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: y in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const y of u) {
        const A = await y.key, $ = await y.value;
        d.push({
          key: A,
          value: $,
          alwaysSet: y.alwaysSet
        });
      }
      return d;
    }).then((d) => K.mergeObjectSync(n, d)) : K.mergeObjectSync(n, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return v.errToObj, new N({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var s, i;
          const a = ((i = (s = this._def).errorMap) == null ? void 0 : i.call(s, r, n).message) ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: v.errToObj(t).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new N({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new N({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new N({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new N({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: b.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new N({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const n of C.objectKeys(t))
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new N({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const n of C.objectKeys(this.shape))
      t[n] || (r[n] = this.shape[n]);
    return new N({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return qe(this);
  }
  partial(t) {
    const r = {};
    for (const n of C.objectKeys(this.shape)) {
      const a = this.shape[n];
      t && !t[n] ? r[n] = a : r[n] = a.optional();
    }
    return new N({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const n of C.objectKeys(this.shape))
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof oe; )
          s = s._def.innerType;
        r[n] = s;
      }
    return new N({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Os(C.objectKeys(this.shape));
  }
}
N.create = (e, t) => new N({
  shape: () => e,
  unknownKeys: "strip",
  catchall: be.create(),
  typeName: b.ZodObject,
  ...T(t)
});
N.strictCreate = (e, t) => new N({
  shape: () => e,
  unknownKeys: "strict",
  catchall: be.create(),
  typeName: b.ZodObject,
  ...T(t)
});
N.lazycreate = (e, t) => new N({
  shape: e,
  unknownKeys: "strip",
  catchall: be.create(),
  typeName: b.ZodObject,
  ...T(t)
});
class Bt extends w {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new ce(o.ctx.common.issues));
      return p(r, {
        code: h.invalid_union,
        unionErrors: i
      }), S;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const u of n) {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, y = u._parseSync({
          data: r.data,
          path: r.path,
          parent: d
        });
        if (y.status === "valid")
          return y;
        y.status === "dirty" && !s && (s = { result: y, ctx: d }), d.common.issues.length && i.push(d.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((u) => new ce(u));
      return p(r, {
        code: h.invalid_union,
        unionErrors: o
      }), S;
    }
  }
  get options() {
    return this._def.options;
  }
}
Bt.create = (e, t) => new Bt({
  options: e,
  typeName: b.ZodUnion,
  ...T(t)
});
const se = (e) => e instanceof Ft ? se(e.schema) : e instanceof ue ? se(e.innerType()) : e instanceof Gt ? [e.value] : e instanceof Oe ? e.options : e instanceof Jt ? C.objectValues(e.enum) : e instanceof Qt ? se(e._def.innerType) : e instanceof qt ? [void 0] : e instanceof Kt ? [null] : e instanceof oe ? [void 0, ...se(e.unwrap())] : e instanceof ke ? [null, ...se(e.unwrap())] : e instanceof ks || e instanceof Xt ? se(e.unwrap()) : e instanceof Yt ? se(e._def.innerType) : [];
class An extends w {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== m.object)
      return p(r, {
        code: h.invalid_type,
        expected: m.object,
        received: r.parsedType
      }), S;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (p(r, {
      code: h.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), S);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const i = se(s.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (a.has(o))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(o)}`);
        a.set(o, s);
      }
    }
    return new An({
      typeName: b.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: a,
      ...T(n)
    });
  }
}
function rn(e, t) {
  const r = ve(e), n = ve(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === m.object && n === m.object) {
    const a = C.objectKeys(t), s = C.objectKeys(e).filter((o) => a.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of s) {
      const u = rn(e[o], t[o]);
      if (!u.valid)
        return { valid: !1 };
      i[o] = u.data;
    }
    return { valid: !0, data: i };
  } else if (r === m.array && n === m.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const i = e[s], o = t[s], u = rn(i, o);
      if (!u.valid)
        return { valid: !1 };
      a.push(u.data);
    }
    return { valid: !0, data: a };
  } else return r === m.date && n === m.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Zt extends w {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = (s, i) => {
      if ($a(s) || $a(i))
        return S;
      const o = rn(s.value, i.value);
      return o.valid ? ((Ea(s) || Ea(i)) && r.dirty(), { status: r.value, value: o.data }) : (p(n, {
        code: h.invalid_intersection_types
      }), S);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Zt.create = (e, t, r) => new Zt({
  left: e,
  right: t,
  typeName: b.ZodIntersection,
  ...T(r)
});
class Ce extends w {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.array)
      return p(n, {
        code: h.invalid_type,
        expected: m.array,
        received: n.parsedType
      }), S;
    if (n.data.length < this._def.items.length)
      return p(n, {
        code: h.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), S;
    !this._def.rest && n.data.length > this._def.items.length && (p(n, {
      code: h.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, o) => {
      const u = this._def.items[o] || this._def.rest;
      return u ? u._parse(new X(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => K.mergeArray(r, i)) : K.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Ce({
      ...this._def,
      rest: t
    });
  }
}
Ce.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ce({
    items: e,
    typeName: b.ZodTuple,
    rest: null,
    ...T(t)
  });
};
class Wt extends w {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.object)
      return p(n, {
        code: h.invalid_type,
        expected: m.object,
        received: n.parsedType
      }), S;
    const a = [], s = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      a.push({
        key: s._parse(new X(n, o, n.path, o)),
        value: i._parse(new X(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? K.mergeObjectAsync(r, a) : K.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof w ? new Wt({
      keyType: t,
      valueType: r,
      typeName: b.ZodRecord,
      ...T(n)
    }) : new Wt({
      keyType: ie.create(),
      valueType: t,
      typeName: b.ZodRecord,
      ...T(r)
    });
  }
}
class nn extends w {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.map)
      return p(n, {
        code: h.invalid_type,
        expected: m.map,
        received: n.parsedType
      }), S;
    const a = this._def.keyType, s = this._def.valueType, i = [...n.data.entries()].map(([o, u], d) => ({
      key: a._parse(new X(n, o, n.path, [d, "key"])),
      value: s._parse(new X(n, u, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of i) {
          const d = await u.key, y = await u.value;
          if (d.status === "aborted" || y.status === "aborted")
            return S;
          (d.status === "dirty" || y.status === "dirty") && r.dirty(), o.set(d.value, y.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const u of i) {
        const d = u.key, y = u.value;
        if (d.status === "aborted" || y.status === "aborted")
          return S;
        (d.status === "dirty" || y.status === "dirty") && r.dirty(), o.set(d.value, y.value);
      }
      return { status: r.value, value: o };
    }
  }
}
nn.create = (e, t, r) => new nn({
  valueType: t,
  keyType: e,
  typeName: b.ZodMap,
  ...T(r)
});
class Qe extends w {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.set)
      return p(n, {
        code: h.invalid_type,
        expected: m.set,
        received: n.parsedType
      }), S;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (p(n, {
      code: h.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (p(n, {
      code: h.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function i(u) {
      const d = /* @__PURE__ */ new Set();
      for (const y of u) {
        if (y.status === "aborted")
          return S;
        y.status === "dirty" && r.dirty(), d.add(y.value);
      }
      return { status: r.value, value: d };
    }
    const o = [...n.data.values()].map((u, d) => s._parse(new X(n, u, n.path, d)));
    return n.common.async ? Promise.all(o).then((u) => i(u)) : i(o);
  }
  min(t, r) {
    return new Qe({
      ...this._def,
      minSize: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new Qe({
      ...this._def,
      maxSize: { value: t, message: v.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Qe.create = (e, t) => new Qe({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: b.ZodSet,
  ...T(t)
});
class Ft extends w {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Ft.create = (e, t) => new Ft({
  getter: e,
  typeName: b.ZodLazy,
  ...T(t)
});
class Gt extends w {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return p(r, {
        received: r.data,
        code: h.invalid_literal,
        expected: this._def.value
      }), S;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Gt.create = (e, t) => new Gt({
  value: e,
  typeName: b.ZodLiteral,
  ...T(t)
});
function Os(e, t) {
  return new Oe({
    values: e,
    typeName: b.ZodEnum,
    ...T(t)
  });
}
class Oe extends w {
  constructor() {
    super(...arguments), ft.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        expected: C.joinValues(n),
        received: r.parsedType,
        code: h.invalid_type
      }), S;
    }
    if (Ut(this, ft, "f") || Rs(this, ft, new Set(this._def.values), "f"), !Ut(this, ft, "f").has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        received: r.data,
        code: h.invalid_enum_value,
        options: n
      }), S;
    }
    return z(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return Oe.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return Oe.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
ft = /* @__PURE__ */ new WeakMap();
Oe.create = Os;
class Jt extends w {
  constructor() {
    super(...arguments), ht.set(this, void 0);
  }
  _parse(t) {
    const r = C.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== m.string && n.parsedType !== m.number) {
      const a = C.objectValues(r);
      return p(n, {
        expected: C.joinValues(a),
        received: n.parsedType,
        code: h.invalid_type
      }), S;
    }
    if (Ut(this, ht, "f") || Rs(this, ht, new Set(C.getValidEnumValues(this._def.values)), "f"), !Ut(this, ht, "f").has(t.data)) {
      const a = C.objectValues(r);
      return p(n, {
        received: n.data,
        code: h.invalid_enum_value,
        options: a
      }), S;
    }
    return z(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
ht = /* @__PURE__ */ new WeakMap();
Jt.create = (e, t) => new Jt({
  values: e,
  typeName: b.ZodNativeEnum,
  ...T(t)
});
class zt extends w {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== m.promise && r.common.async === !1)
      return p(r, {
        code: h.invalid_type,
        expected: m.promise,
        received: r.parsedType
      }), S;
    const n = r.parsedType === m.promise ? r.data : Promise.resolve(r.data);
    return z(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
zt.create = (e, t) => new zt({
  type: e,
  typeName: b.ZodPromise,
  ...T(t)
});
class ue extends w {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === b.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = this._def.effect || null, s = {
      addIssue: (i) => {
        p(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return S;
          const u = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return u.status === "aborted" ? S : u.status === "dirty" || r.value === "dirty" ? dt(u.value) : u;
        });
      {
        if (r.value === "aborted")
          return S;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? S : o.status === "dirty" || r.value === "dirty" ? dt(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const i = (o) => {
        const u = a.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? S : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? S : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Ge(i))
          return i;
        const o = a.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => Ge(i) ? Promise.resolve(a.transform(i.value, s)).then((o) => ({
          status: r.value,
          value: o
        })) : i);
    C.assertNever(a);
  }
}
ue.create = (e, t, r) => new ue({
  schema: e,
  typeName: b.ZodEffects,
  effect: t,
  ...T(r)
});
ue.createWithPreprocess = (e, t, r) => new ue({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: b.ZodEffects,
  ...T(r)
});
class oe extends w {
  _parse(t) {
    return this._getType(t) === m.undefined ? z(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
oe.create = (e, t) => new oe({
  innerType: e,
  typeName: b.ZodOptional,
  ...T(t)
});
class ke extends w {
  _parse(t) {
    return this._getType(t) === m.null ? z(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ke.create = (e, t) => new ke({
  innerType: e,
  typeName: b.ZodNullable,
  ...T(t)
});
class Qt extends w {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === m.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Qt.create = (e, t) => new Qt({
  innerType: e,
  typeName: b.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...T(t)
});
class Yt extends w {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Lt(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new ce(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new ce(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Yt.create = (e, t) => new Yt({
  innerType: e,
  typeName: b.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...T(t)
});
class an extends w {
  _parse(t) {
    if (this._getType(t) !== m.nan) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.nan,
        received: n.parsedType
      }), S;
    }
    return { status: "valid", value: t.data };
  }
}
an.create = (e) => new an({
  typeName: b.ZodNaN,
  ...T(e)
});
class ks extends w {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Tn extends w {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? S : s.status === "dirty" ? (r.dirty(), dt(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? S : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new Tn({
      in: t,
      out: r,
      typeName: b.ZodPipeline
    });
  }
}
class Xt extends w {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (a) => (Ge(a) && (a.value = Object.freeze(a.value)), a);
    return Lt(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Xt.create = (e, t) => new Xt({
  innerType: e,
  typeName: b.ZodReadonly,
  ...T(t)
});
function Ra(e, t) {
  const r = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof r == "string" ? { message: r } : r;
}
function Is(e, t = {}, r) {
  return e ? yt.create().superRefine((n, a) => {
    const s = e(n);
    if (s instanceof Promise)
      return s.then((i) => {
        if (!i) {
          const o = Ra(t, n), u = o.fatal ?? r ?? !0;
          a.addIssue({ code: "custom", ...o, fatal: u });
        }
      });
    if (!s) {
      const i = Ra(t, n), o = i.fatal ?? r ?? !0;
      a.addIssue({ code: "custom", ...i, fatal: o });
    }
  }) : yt.create();
}
N.lazycreate;
var b;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(b || (b = {}));
const yr = (e, t = {
  message: `Input not instance of ${e.name}`
}) => Is((r) => r instanceof e, t), c = ie.create, mr = Je.create;
an.create;
ze.create;
const E = Yr.create;
pt.create;
Xr.create;
qt.create;
Kt.create;
yt.create;
en.create;
be.create;
tn.create;
const R = Y.create, f = N.create;
N.strictCreate;
const I = Bt.create, M = An.create;
Zt.create;
Ce.create;
const _t = Wt.create;
nn.create;
Qe.create;
const re = Ft.create, l = Gt.create, G = Oe.create;
Jt.create;
zt.create;
ue.create;
const F = oe.create;
ke.create;
ue.createWithPreprocess;
var x = (e) => e, qm = class {
  /**
   * @package
   */
  constructor(e, t, r) {
    this.versionMap = e, this.latestVersion = t, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(e) {
    let t = this.getVersion(e);
    if (t === null)
      return !1;
    const r = this.versionMap[t];
    return r ? r.schema.safeParse(e).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(e) {
    return this.versionMap[this.latestVersion].schema.safeParse(e).success;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(e) {
    const t = this.getVersion(e);
    if (t === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[t];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(e);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: t,
          versionDef: r,
          error: n.error
        }
      };
    let a = n.data;
    for (let s = t + 1; s <= this.latestVersion; s++) {
      const i = this.versionMap[s];
      if (!i)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: s }
        };
      if (i.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: s }
        };
      a = i.up(a);
    }
    return { type: "ok", value: a };
  }
};
function bt(e) {
  return new qm(e.versionMap, e.latestVersion, e.getVersion);
}
function er(e) {
  return Is((t) => e.is(t)).transform((t) => {
    const r = e.safeParse(t);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
var Km = "__lodash_hash_undefined__";
function Bm(e) {
  return this.__data__.set(e, Km), this;
}
var Zm = Bm;
function Wm(e) {
  return this.__data__.has(e);
}
var Fm = Wm, Gm = is, Jm = Zm, zm = Fm;
function tr(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Gm(); ++t < r; )
    this.add(e[t]);
}
tr.prototype.add = tr.prototype.push = Jm;
tr.prototype.has = zm;
var Qm = tr;
function Ym(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Xm = Ym;
function ev(e, t) {
  return e.has(t);
}
var tv = ev, rv = Qm, nv = Xm, av = tv, sv = 1, iv = 2;
function ov(e, t, r, n, a, s) {
  var i = r & sv, o = e.length, u = t.length;
  if (o != u && !(i && u > o))
    return !1;
  var d = s.get(e), y = s.get(t);
  if (d && y)
    return d == t && y == e;
  var A = -1, $ = !0, B = r & iv ? new rv() : void 0;
  for (s.set(e, t), s.set(t, e); ++A < o; ) {
    var U = e[A], Z = t[A];
    if (n)
      var D = i ? n(Z, U, A, t, e, s) : n(U, Z, A, e, t, s);
    if (D !== void 0) {
      if (D)
        continue;
      $ = !1;
      break;
    }
    if (B) {
      if (!nv(t, function(q, $e) {
        if (!av(B, $e) && (U === q || a(U, q, r, n, s)))
          return B.push($e);
      })) {
        $ = !1;
        break;
      }
    } else if (!(U === Z || a(U, Z, r, n, s))) {
      $ = !1;
      break;
    }
  }
  return s.delete(e), s.delete(t), $;
}
var Ps = ov;
function cv(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var uv = cv;
function lv(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var dv = lv, xa = cr, Ca = Ts, fv = fn, hv = Ps, pv = uv, yv = dv, mv = 1, vv = 2, gv = "[object Boolean]", _v = "[object Date]", bv = "[object Error]", Sv = "[object Map]", Av = "[object Number]", Tv = "[object RegExp]", $v = "[object Set]", Ev = "[object String]", wv = "[object Symbol]", Rv = "[object ArrayBuffer]", xv = "[object DataView]", Oa = xa ? xa.prototype : void 0, Dr = Oa ? Oa.valueOf : void 0;
function Cv(e, t, r, n, a, s, i) {
  switch (r) {
    case xv:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Rv:
      return !(e.byteLength != t.byteLength || !s(new Ca(e), new Ca(t)));
    case gv:
    case _v:
    case Av:
      return fv(+e, +t);
    case bv:
      return e.name == t.name && e.message == t.message;
    case Tv:
    case Ev:
      return e == t + "";
    case Sv:
      var o = pv;
    case $v:
      var u = n & mv;
      if (o || (o = yv), e.size != t.size && !u)
        return !1;
      var d = i.get(e);
      if (d)
        return d == t;
      n |= vv, i.set(e, t);
      var y = hv(o(e), o(t), n, a, s, i);
      return i.delete(e), y;
    case wv:
      if (Dr)
        return Dr.call(e) == Dr.call(t);
  }
  return !1;
}
var Ov = Cv, ka = Ss, kv = 1, Iv = Object.prototype, Pv = Iv.hasOwnProperty;
function Nv(e, t, r, n, a, s) {
  var i = r & kv, o = ka(e), u = o.length, d = ka(t), y = d.length;
  if (u != y && !i)
    return !1;
  for (var A = u; A--; ) {
    var $ = o[A];
    if (!(i ? $ in t : Pv.call(t, $)))
      return !1;
  }
  var B = s.get(e), U = s.get(t);
  if (B && U)
    return B == t && U == e;
  var Z = !0;
  s.set(e, t), s.set(t, e);
  for (var D = i; ++A < u; ) {
    $ = o[A];
    var q = e[$], $e = t[$];
    if (n)
      var Gn = i ? n($e, q, $, t, e, s) : n(q, $e, $, e, t, s);
    if (!(Gn === void 0 ? q === $e || a(q, $e, r, n, s) : Gn)) {
      Z = !1;
      break;
    }
    D || (D = $ == "constructor");
  }
  if (Z && !D) {
    var kt = e.constructor, It = t.constructor;
    kt != It && "constructor" in e && "constructor" in t && !(typeof kt == "function" && kt instanceof kt && typeof It == "function" && It instanceof It) && (Z = !1);
  }
  return s.delete(e), s.delete(t), Z;
}
var Mv = Nv, Lr = os, jv = Ps, Vv = Ov, Hv = Mv, Ia = pr, Pa = hr, Na = pn, Dv = fs, Lv = 1, Ma = "[object Arguments]", ja = "[object Array]", Nt = "[object Object]", Uv = Object.prototype, Va = Uv.hasOwnProperty;
function qv(e, t, r, n, a, s) {
  var i = Pa(e), o = Pa(t), u = i ? ja : Ia(e), d = o ? ja : Ia(t);
  u = u == Ma ? Nt : u, d = d == Ma ? Nt : d;
  var y = u == Nt, A = d == Nt, $ = u == d;
  if ($ && Na(e)) {
    if (!Na(t))
      return !1;
    i = !0, y = !1;
  }
  if ($ && !y)
    return s || (s = new Lr()), i || Dv(e) ? jv(e, t, r, n, a, s) : Vv(e, t, u, r, n, a, s);
  if (!(r & Lv)) {
    var B = y && Va.call(e, "__wrapped__"), U = A && Va.call(t, "__wrapped__");
    if (B || U) {
      var Z = B ? e.value() : e, D = U ? t.value() : t;
      return s || (s = new Lr()), a(Z, D, r, n, s);
    }
  }
  return $ ? (s || (s = new Lr()), Hv(e, t, r, n, a, s)) : !1;
}
var Kv = qv, Bv = Kv, Ha = it;
function Ns(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !Ha(e) && !Ha(t) ? e !== e && t !== t : Bv(e, t, r, n, Ns, a);
}
var Zv = Ns, Wv = Zv;
function Fv(e, t) {
  return Wv(e, t);
}
var Gv = Fv;
const Jv = /* @__PURE__ */ ts(Gv), zv = (e) => ({
  equals(t, r) {
    return t !== void 0 && r !== void 0 ? e.equals(t, r) : t === void 0 && r === void 0;
  }
}), Ur = (e, t) => ({
  equals(r, n) {
    return t.equals(e(r), e(n));
  }
}), Le = {
  equals(e, t) {
    return Jv(e, t);
  }
}, Qv = f({
  id: F(c()),
  // Firebase Firestore ID
  url: c(),
  path: c(),
  headers: R(
    f({
      key: c(),
      value: c(),
      active: E()
    })
  ),
  params: R(
    f({
      key: c(),
      value: c(),
      active: E()
    })
  ),
  name: c(),
  method: c(),
  preRequestScript: c(),
  testScript: c(),
  contentType: c(),
  body: c(),
  rawParams: F(c()),
  auth: F(c()),
  httpUser: F(c()),
  httpPassword: F(c()),
  bearerToken: F(c())
}), Da = x({
  initial: !0,
  schema: Qv
}), $n = f({
  key: c(),
  active: E()
}).and(
  I([
    f({
      isFile: l(!0),
      value: R(yr(Blob).nullable())
    }),
    f({
      isFile: l(!1),
      value: c()
    })
  ])
);
f({
  contentType: l("multipart/form-data"),
  body: R($n)
});
const Yv = I([
  f({
    contentType: l(null),
    body: l(null).catch(null)
  }),
  f({
    contentType: l("multipart/form-data"),
    body: R($n).catch([])
  }),
  f({
    contentType: I([
      l("application/json"),
      l("application/ld+json"),
      l("application/hal+json"),
      l("application/vnd.api+json"),
      l("application/xml"),
      l("application/x-www-form-urlencoded"),
      l("text/html"),
      l("text/plain")
    ]),
    body: c().catch("")
  })
]), le = f({
  authType: l("none")
}), de = f({
  authType: l("basic"),
  username: c().catch(""),
  password: c().catch("")
}), fe = f({
  authType: l("bearer"),
  token: c().catch("")
}), Xv = f({
  authType: l("oauth-2"),
  token: c().catch(""),
  oidcDiscoveryURL: c().catch(""),
  authURL: c().catch(""),
  accessTokenURL: c().catch(""),
  clientID: c().catch(""),
  scope: c().catch("")
}), En = f({
  authType: l("api-key"),
  key: c().catch(""),
  value: c().catch(""),
  addTo: c().catch("Headers")
}), he = f({
  authType: l("inherit")
}), eg = M("authType", [
  le,
  he,
  de,
  fe,
  Xv,
  En
]).and(
  f({
    authActive: E()
  })
), tg = R(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: E().catch(!0)
  })
), Ms = R(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: E().catch(!0)
  })
), js = f({
  v: l("1"),
  id: F(c()),
  // Firebase Firestore ID
  name: c(),
  method: c(),
  endpoint: c(),
  params: tg,
  headers: Ms,
  preRequestScript: c().catch(""),
  testScript: c().catch(""),
  auth: eg,
  body: Yv
});
function rg(e) {
  return {
    contentType: "application/json",
    body: e.contentType === "application/json" ? e.rawParams ?? "" : ""
  };
}
function ng(e) {
  return !e.auth || e.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : e.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: e.httpUser ?? "",
    password: e.httpPassword ?? ""
  } : e.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: e.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const ag = x({
  initial: !1,
  schema: js,
  up(e) {
    const {
      url: t,
      path: r,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: u
    } = e, d = `${t}${r}`, y = rg(e), A = ng(e), $ = {
      v: "1",
      endpoint: d,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: u,
      body: y,
      auth: A
    };
    return e.id && ($.id = e.id), $;
  }
}), vr = R(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: E().catch(!0)
  })
), Vs = js.extend({
  v: l("2"),
  requestVariables: vr
}), sg = x({
  initial: !1,
  schema: Vs,
  up(e) {
    return {
      ...e,
      v: "2",
      requestVariables: []
    };
  }
}), Hs = f({
  grantType: l("AUTHORIZATION_CODE"),
  authEndpoint: c().trim(),
  tokenEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch(""),
  isPKCE: E(),
  codeVerifierMethod: I([l("plain"), l("S256")]).optional()
}), gr = f({
  grantType: l("CLIENT_CREDENTIALS"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch("")
}), _r = f({
  grantType: l("PASSWORD"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  username: c().trim(),
  password: c().trim(),
  token: c().catch("")
}), St = f({
  grantType: l("IMPLICIT"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch("")
}), br = f({
  authType: l("oauth-2"),
  grantTypeInfo: M("grantType", [
    Hs,
    gr,
    _r,
    St
  ]),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), ig = M("authType", [
  le,
  he,
  de,
  fe,
  br,
  En
]).and(
  f({
    authActive: E()
  })
), Ds = Vs.extend({
  v: l("3"),
  auth: ig
}), og = x({
  initial: !1,
  schema: Ds,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: "3",
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: "3",
      auth: {
        ...e.auth
      }
    };
  }
}), Pe = En.extend({
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), cg = M("authType", [
  le,
  he,
  de,
  fe,
  br,
  Pe
]).and(
  f({
    authActive: E()
  })
), Ls = Ds.extend({
  v: l("4"),
  auth: cg
}), ug = x({
  schema: Ls,
  initial: !1,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: "4",
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      auth: {
        ...e.auth
      },
      v: "4"
    };
  }
}), Us = Hs.extend({
  clientSecret: c().optional()
}), Sr = br.extend({
  grantTypeInfo: M("grantType", [
    Us,
    gr,
    _r,
    St
  ])
}), qs = M("authType", [
  le,
  he,
  de,
  fe,
  Sr,
  Pe
]).and(
  f({
    authActive: E()
  })
), Ks = Ls.extend({
  v: l("5"),
  auth: qs
}), lg = x({
  schema: Ks,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Bs = I([
  f({
    contentType: l(null),
    body: l(null).catch(null)
  }),
  f({
    contentType: l("multipart/form-data"),
    body: R($n).catch([])
  }),
  f({
    contentType: I([
      l("application/json"),
      l("application/ld+json"),
      l("application/hal+json"),
      l("application/vnd.api+json"),
      l("application/xml"),
      l("text/xml"),
      l("application/x-www-form-urlencoded"),
      l("text/html"),
      l("text/plain")
    ]),
    body: c().catch("")
  })
]), Zs = Ks.extend({
  v: l("6"),
  body: Bs
}), dg = x({
  schema: Zs,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "6"
    };
  }
}), wn = Us.extend({
  refreshToken: c().optional()
}), Ws = f({
  authType: l("oauth-2"),
  grantTypeInfo: M("grantType", [
    wn,
    gr,
    _r,
    St
  ]),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ar = R(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: E().catch(!0),
    description: c().catch("")
  })
), At = R(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: E().catch(!0),
    description: c().catch("")
  })
), ct = f({
  authType: l("aws-signature"),
  accessKey: c().catch(""),
  secretKey: c().catch(""),
  region: c().catch(""),
  serviceName: c().catch(""),
  serviceToken: c().optional(),
  signature: f({}).optional(),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Fs = M("authType", [
  le,
  he,
  de,
  fe,
  Ws,
  Pe,
  ct
]).and(
  f({
    authActive: E()
  })
), Gs = Zs.extend({
  v: l("7"),
  params: Ar,
  headers: At,
  auth: Fs
}), fg = x({
  schema: Gs,
  initial: !1,
  up(e) {
    const t = e.params.map((n) => ({
      ...n,
      description: ""
    })), r = e.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...e,
      v: "7",
      params: t,
      headers: r
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), hg = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, Js = gr.extend({
  clientSecret: c().optional()
}), zs = _r.extend({
  clientSecret: c().optional()
}), pg = f({
  authType: l("oauth-2"),
  grantTypeInfo: M("grantType", [
    wn,
    Js,
    zs,
    St
  ]),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Tr = f({
  authType: l("digest"),
  username: c().catch(""),
  password: c().catch(""),
  realm: c().catch(""),
  nonce: c().catch(""),
  algorithm: G(["MD5", "MD5-sess"]).catch("MD5"),
  qop: G(["auth", "auth-int"]).catch("auth"),
  nc: c().catch(""),
  cnonce: c().catch(""),
  opaque: c().catch(""),
  disableRetry: E().catch(!1)
}), $r = M("authType", [
  le,
  he,
  de,
  fe,
  pg,
  Pe,
  ct,
  Tr
]).and(
  f({
    authActive: E()
  })
), Qs = I(
  Object.keys(hg).map((e) => l(parseInt(e)))
), Ys = R(
  f({
    key: c(),
    value: c()
  })
), yg = f({
  v: l("1"),
  name: c(),
  method: c(),
  endpoint: c(),
  headers: At,
  params: Ar,
  body: Bs,
  auth: $r,
  requestVariables: vr
}), mg = f({
  name: c(),
  originalRequest: yg,
  status: c(),
  code: F(Qs),
  headers: Ys,
  body: c()
}), vg = _t(
  c(),
  mg
), Xs = Gs.extend({
  v: l("8"),
  auth: $r,
  responses: vg
}), gg = x({
  schema: Xs,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), ei = f({
  key: c(),
  active: E(),
  contentType: c().optional().catch(void 0)
}).and(
  I([
    f({
      isFile: l(!0),
      value: R(yr(Blob).nullable()).catch([])
    }),
    f({
      isFile: l(!1),
      value: c()
    })
  ])
).transform((e) => e.isFile && Array.isArray(e.value) && e.value.length === 0 ? {
  ...e,
  isFile: !1,
  value: ""
} : e), ti = I([
  f({
    contentType: l(null),
    body: l(null).catch(null)
  }),
  f({
    contentType: l("multipart/form-data"),
    body: R(ei).catch([]),
    showIndividualContentType: E().optional().catch(!1)
  }),
  f({
    contentType: l("application/octet-stream"),
    body: yr(File).nullable().catch(null)
  }),
  f({
    contentType: I([
      l("application/json"),
      l("application/ld+json"),
      l("application/hal+json"),
      l("application/vnd.api+json"),
      l("application/xml"),
      l("text/xml"),
      l("application/x-www-form-urlencoded"),
      l("binary"),
      l("text/html"),
      l("text/plain")
    ]),
    body: c().catch("")
  })
]), Er = f({
  v: l("2"),
  name: c(),
  method: c(),
  endpoint: c(),
  headers: At,
  params: Ar,
  body: ti,
  auth: $r,
  requestVariables: vr
}), wr = f({
  name: c(),
  originalRequest: Er,
  status: c(),
  code: F(Qs).nullable().catch(null),
  headers: Ys,
  body: c()
}), _g = _t(
  c(),
  wr
), ri = Xs.extend({
  v: l("9"),
  body: ti,
  responses: _g
}), bg = x({
  schema: ri,
  initial: !1,
  up(e) {
    const t = Object.fromEntries(
      Object.entries(e.responses).map(([r, n]) => [
        r,
        {
          ...n,
          originalRequest: {
            ...n.originalRequest,
            v: "2"
          }
        }
      ])
    );
    return {
      ...e,
      v: "9",
      responses: t
    };
  }
}), Rn = I([
  f({
    contentType: l(null),
    body: l(null).catch(null)
  }),
  f({
    contentType: l("multipart/form-data"),
    body: R(ei).catch([]),
    showIndividualContentType: E().optional().catch(!1),
    isBulkEditing: E().optional().catch(!1)
  }),
  f({
    contentType: l("application/octet-stream"),
    body: yr(File).nullable().catch(null)
  }),
  f({
    contentType: l("application/x-www-form-urlencoded"),
    body: c().catch(""),
    isBulkEditing: E().optional().catch(!1)
  }),
  f({
    contentType: I([
      l("application/json"),
      l("application/ld+json"),
      l("application/hal+json"),
      l("application/vnd.api+json"),
      l("application/xml"),
      l("text/xml"),
      l("binary"),
      l("text/html"),
      l("text/plain")
    ]),
    body: c().catch("")
  })
]), ni = ri.extend({
  v: l("10"),
  body: Rn
}), Sg = x({
  schema: ni,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "10"
    };
  }
}), Ag = Js.extend({
  clientAuthentication: G(["AS_BASIC_AUTH_HEADERS", "IN_BODY"])
}), Rr = f({
  authType: l("oauth-2"),
  grantTypeInfo: M("grantType", [
    wn,
    Ag,
    zs,
    St
  ]),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), xn = M("authType", [
  le,
  he,
  de,
  fe,
  Rr,
  Pe,
  ct,
  Tr
]).and(
  f({
    authActive: E()
  })
), Tg = Er.extend({
  v: l("3"),
  auth: xn,
  body: Rn
}), $g = wr.extend({
  originalRequest: Tg
}), Eg = _t(
  c(),
  $g
), ai = ni.extend({
  v: l("11"),
  auth: xn,
  responses: Eg
}), wg = x({
  schema: ai,
  initial: !1,
  up(e) {
    const t = e.auth, r = Object.fromEntries(
      Object.entries(e.responses).map(([n, a]) => [
        n,
        {
          ...a,
          originalRequest: {
            ...a.originalRequest,
            auth: t.authType === "oauth-2" ? {
              ...t,
              grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
                ...t.grantTypeInfo,
                clientAuthentication: "IN_BODY"
              } : t.grantTypeInfo
            } : t,
            // just following the previous pattern here, but is this a good idea to overwrite the request version ?
            v: "3"
          }
        }
      ])
    );
    return {
      ...e,
      v: "11",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t,
      responses: r
    };
  }
}), si = f({
  authType: l("hawk"),
  authId: c().catch(""),
  authKey: c().catch(""),
  algorithm: G(["sha256", "sha1"]).catch("sha256"),
  includePayloadHash: E().catch(!1),
  // Optional fields
  user: c().optional(),
  nonce: c().optional(),
  ext: c().optional(),
  app: c().optional(),
  dlg: c().optional(),
  timestamp: c().optional()
}), ii = f({
  authType: l("akamai-eg"),
  accessToken: c().catch(""),
  clientToken: c().catch(""),
  clientSecret: c().catch(""),
  // Optional fields
  nonce: c().optional(),
  timestamp: c().optional(),
  host: c().optional(),
  headersToSign: c().optional(),
  maxBodySize: c().optional()
}), Cn = M("authType", [
  le,
  he,
  de,
  fe,
  Rr,
  Pe,
  ct,
  Tr,
  si,
  ii
]).and(
  f({
    authActive: E()
  })
), Rg = Er.extend({
  v: l("4"),
  auth: Cn
}), xg = wr.extend({
  originalRequest: Rg
}), Cg = _t(
  c(),
  xg
), oi = ai.extend({
  v: l("12"),
  auth: Cn,
  responses: Cg
}), Og = x({
  schema: oi,
  initial: !1,
  up(e) {
    const t = Object.fromEntries(
      Object.entries(e.responses).map(([r, n]) => [
        r,
        {
          ...n,
          originalRequest: {
            ...n.originalRequest,
            v: "4"
          }
        }
      ])
    );
    return {
      ...e,
      v: "12",
      responses: t
    };
  }
}), kg = f({
  authType: l("jwt"),
  secret: c().catch(""),
  privateKey: c().catch(""),
  // For RSA/ECDSA algorithms
  algorithm: G([
    "HS256",
    "HS384",
    "HS512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512",
    "ES256",
    "ES384",
    "ES512"
  ]).catch("HS256"),
  payload: c().catch("{}"),
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS"),
  isSecretBase64Encoded: E().catch(!1),
  headerPrefix: c().catch("Bearer "),
  paramName: c().catch("token"),
  jwtHeaders: c().catch("{}")
}), xr = M("authType", [
  le,
  he,
  de,
  fe,
  Rr,
  Pe,
  ct,
  Tr,
  si,
  ii,
  kg
]).and(
  f({
    authActive: E()
  })
), Ig = Er.extend({
  v: l("5"),
  auth: xr
}), Pg = wr.extend({
  originalRequest: Ig
}), ci = _t(
  c(),
  Pg
), Ng = oi.extend({
  v: l("13"),
  auth: xr,
  responses: ci
}), Mg = x({
  schema: Ng,
  initial: !1,
  up(e) {
    const t = Object.fromEntries(
      Object.entries(e.responses).map(([r, n]) => [
        r,
        {
          ...n,
          originalRequest: {
            ...n.originalRequest,
            v: "5"
          }
        }
      ])
    );
    return {
      ...e,
      v: "13",
      responses: t
    };
  }
}), jg = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "application/octet-stream": "binary",
  "text/html": "html",
  "text/plain": "plain"
}, CS = Object.keys(
  jg
), Vg = f({
  // v is a stringified number
  v: c().regex(/^\d+$/).transform(Number)
}), Cr = bt({
  latestVersion: 13,
  versionMap: {
    0: Da,
    1: ag,
    2: sg,
    3: og,
    4: ug,
    5: lg,
    6: dg,
    7: fg,
    8: gg,
    9: bg,
    10: Sg,
    11: wg,
    12: Og,
    13: Mg
  },
  getVersion(e) {
    const t = Vg.safeParse(e);
    return t.success ? t.data.v : Da.schema.safeParse(e).success ? 0 : null;
  }
}), Hg = Eo({
  id: zv(me),
  v: me,
  auth: Le,
  body: Le,
  endpoint: me,
  headers: Ur(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Le
  ),
  params: Ur(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Le
  ),
  method: me,
  name: me,
  preRequestScript: me,
  testScript: me,
  requestVariables: Ur(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Le
  ),
  responses: Le
}), ui = "13", OS = "5", kS = Hg.equals;
function IS(e, t) {
  const r = mm(t);
  if (e && typeof e == "object") {
    if ("id" in e && typeof e.id == "string" && (r.id = e.id), "name" in e && typeof e.name == "string" && (r.name = e.name), "method" in e && typeof e.method == "string" && (r.method = e.method), "endpoint" in e && typeof e.endpoint == "string" && (r.endpoint = e.endpoint), "preRequestScript" in e && typeof e.preRequestScript == "string" && (r.preRequestScript = e.preRequestScript), "testScript" in e && typeof e.testScript == "string" && (r.testScript = e.testScript), "body" in e) {
      const n = Rn.safeParse(e.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in e) {
      const n = xr.safeParse(e.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in e) {
      const n = Ar.safeParse(e.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in e) {
      const n = At.safeParse(e.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in e) {
      const n = vr.safeParse(e.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
    if ("responses" in e) {
      const n = ci.safeParse(e.responses);
      n.success && (r.responses = n.data);
    }
  }
  return r;
}
function PS(e) {
  return {
    v: ui,
    ...e
  };
}
function Dg() {
  return {
    v: ui,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: [],
    responses: {}
  };
}
function NS(e) {
  return Cr.isLatest(e);
}
function Lg(e) {
  const t = Cr.safeParse(e);
  return t.type === "ok" ? t.value : Dg();
}
const On = f({
  key: c().catch(""),
  value: c().catch(""),
  active: E().catch(!0)
}), Ug = f({
  v: l(1),
  name: c(),
  url: c(),
  headers: R(On).catch([]),
  query: c(),
  variables: c()
}), qg = x({
  initial: !0,
  schema: Ug
}), Ne = f({
  authType: l("none")
}), Me = f({
  authType: l("basic"),
  username: c().catch(""),
  password: c().catch("")
}), je = f({
  authType: l("bearer"),
  token: c().catch("")
}), Kg = f({
  authType: l("oauth-2"),
  token: c().catch(""),
  oidcDiscoveryURL: c().catch(""),
  authURL: c().catch(""),
  accessTokenURL: c().catch(""),
  clientID: c().catch(""),
  scope: c().catch("")
}), kn = f({
  authType: l("api-key"),
  key: c().catch(""),
  value: c().catch(""),
  addTo: c().catch("Headers")
}), Ve = f({
  authType: l("inherit")
}), Bg = M("authType", [
  Ne,
  Me,
  je,
  Kg,
  kn,
  Ve
]).and(
  f({
    authActive: E()
  })
), li = f({
  id: F(c()),
  v: l(2),
  name: c(),
  url: c(),
  headers: R(On).catch([]),
  query: c(),
  variables: c(),
  auth: Bg
}), Zg = x({
  initial: !1,
  schema: li,
  up(e) {
    return {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), Wg = M("authType", [
  Ne,
  Ve,
  Me,
  je,
  kn,
  br
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: E()
  })
), di = li.extend({
  v: l(3),
  auth: Wg
}), Fg = x({
  initial: !1,
  schema: di,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: 3,
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: 3,
      auth: {
        ...e.auth
      }
    };
  }
}), Tt = kn.extend({
  addTo: G(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Gg = M("authType", [
  Ne,
  Ve,
  Me,
  je,
  Tt,
  Sr
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: E()
  })
), fi = di.extend({
  v: l(4),
  auth: Gg
}), Jg = x({
  initial: !1,
  schema: fi,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: 4,
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      v: 4,
      auth: {
        ...e.auth
      }
    };
  }
}), hi = M("authType", [
  Ne,
  Ve,
  Me,
  je,
  Tt,
  Sr
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: E()
  })
), pi = fi.extend({
  v: l(5),
  auth: hi
}), zg = x({
  initial: !1,
  schema: pi,
  up(e) {
    return {
      ...e,
      v: 5
    };
  }
}), In = ct, yi = f({
  key: c().catch(""),
  value: c().catch(""),
  active: E().catch(!0),
  description: c().catch("")
}), mi = M("authType", [
  Ne,
  Ve,
  Me,
  je,
  Sr,
  Tt,
  In
]).and(
  f({
    authActive: E()
  })
), vi = pi.extend({
  v: l(6),
  auth: mi,
  headers: R(yi).catch([])
}), Qg = x({
  schema: vi,
  initial: !1,
  up(e) {
    const t = e.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...e,
      v: 6,
      headers: t
    };
  }
}), gi = M("authType", [
  Ne,
  Ve,
  Me,
  je,
  Ws,
  Tt,
  In
]).and(
  f({
    authActive: E()
  })
), _i = vi.extend({
  v: l(7),
  auth: gi
}), Yg = x({
  schema: _i,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), Or = M("authType", [
  Ne,
  Ve,
  Me,
  je,
  Rr,
  Tt,
  In
]).and(
  f({
    authActive: E()
  })
), Xg = _i.extend({
  v: l(8),
  auth: Or
}), e_ = x({
  schema: Xg,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: 8,
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), bi = 8, t_ = f({
  v: mr()
}), Pn = bt({
  latestVersion: 8,
  versionMap: {
    1: qg,
    2: Zg,
    3: Fg,
    4: Jg,
    5: zg,
    6: Qg,
    7: Yg,
    8: e_
  },
  getVersion(e) {
    const t = t_.safeParse(e);
    return t.success ? t.data.v : null;
  }
}), r_ = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function n_() {
  return {
    v: bi,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: r_,
    auth: {
      authType: "inherit",
      authActive: !0
    }
  };
}
function a_(e) {
  const t = Pn.safeParse(e);
  return t.type === "ok" ? t.value : n_();
}
function MS(e) {
  return {
    v: bi,
    ...e
  };
}
const s_ = f({
  v: l(1),
  id: F(c()),
  // For Firestore ID data
  name: c(),
  requests: R(
    re(
      () => I([
        er(Cr),
        er(Pn)
      ])
    )
  )
}), Si = s_.extend({
  folders: re(() => R(Si))
}), La = x({
  initial: !0,
  schema: Si
}), Ai = f({
  v: l(2),
  id: F(c()),
  // For Firestore ID data
  name: c(),
  requests: R(
    re(
      () => I([
        er(Cr),
        er(Pn)
      ])
    )
  ),
  auth: I([qs, hi]),
  headers: I([Ms, R(On)])
}), Ti = Ai.extend({
  folders: re(() => R(Ti))
}), i_ = x({
  initial: !1,
  schema: Ti,
  up(e) {
    const t = {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: []
    };
    return e.id && (t.id = e.id), t;
  }
}), $i = Ai.extend({
  v: l(3),
  // AWS Signature Authorization type addition
  auth: I([Fs, mi]),
  // `description` field addition under `headers`
  headers: I([At, R(yi)])
}), Ei = $i.extend({
  folders: re(() => R(Ei))
}), o_ = x({
  initial: !1,
  schema: Ei,
  up(e) {
    const t = e.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...e,
      v: 3,
      headers: t
    };
  }
}), wi = $i.extend({
  v: l(4),
  auth: I([$r, gi])
}), Ri = wi.extend({
  folders: re(() => R(Ri))
}), c_ = x({
  initial: !1,
  schema: Ri,
  // @ts-expect-error
  up(e) {
    return {
      ...e,
      v: 4
    };
  }
});
var L = [];
for (var qr = 0; qr < 256; ++qr)
  L.push((qr + 256).toString(16).slice(1));
function u_(e, t = 0) {
  return (L[e[t + 0]] + L[e[t + 1]] + L[e[t + 2]] + L[e[t + 3]] + "-" + L[e[t + 4]] + L[e[t + 5]] + "-" + L[e[t + 6]] + L[e[t + 7]] + "-" + L[e[t + 8]] + L[e[t + 9]] + "-" + L[e[t + 10]] + L[e[t + 11]] + L[e[t + 12]] + L[e[t + 13]] + L[e[t + 14]] + L[e[t + 15]]).toLowerCase();
}
var Mt, l_ = new Uint8Array(16);
function d_() {
  if (!Mt && (Mt = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Mt))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Mt(l_);
}
var f_ = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const Ua = {
  randomUUID: f_
};
function h_(e, t, r) {
  if (Ua.randomUUID && !t && !e)
    return Ua.randomUUID();
  e = e || {};
  var n = e.random || (e.rng || d_)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, u_(n);
}
const xi = (e = "") => {
  const t = Date.now().toString(36), r = h_();
  return `${e}_${t}_${r}`;
}, Ci = wi.extend({
  v: l(5),
  _ref_id: c().optional()
}), Oi = Ci.extend({
  folders: re(() => R(Oi))
}), p_ = x({
  initial: !1,
  schema: Oi,
  // @ts-expect-error
  up(e) {
    return {
      ...e,
      v: 5,
      _ref_id: xi("coll")
    };
  }
}), ki = Ci.extend({
  v: l(6),
  auth: I([xn, Or])
}), Ii = ki.extend({
  folders: re(() => R(Ii))
}), y_ = x({
  initial: !1,
  schema: Ii,
  // @ts-expect-error
  up(e) {
    const t = e.auth, r = t.authType === "oauth-2" ? {
      ...t,
      grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
        ...t.grantTypeInfo,
        clientAuthentication: "IN_BODY"
      } : t.grantTypeInfo
    } : t;
    return {
      ...e,
      auth: r,
      v: 6
    };
  }
}), Pi = ki.extend({
  v: l(7),
  auth: I([Cn, Or])
}), Ni = Pi.extend({
  folders: re(() => R(Ni))
}), m_ = x({
  initial: !1,
  schema: Ni,
  // @ts-expect-error
  up(e) {
    return {
      ...e,
      v: 7
    };
  }
}), v_ = Pi.extend({
  v: l(8),
  auth: I([xr, Or])
}), Mi = v_.extend({
  folders: re(() => R(Mi))
}), g_ = x({
  initial: !1,
  schema: Mi,
  // @ts-expect-error
  up(e) {
    return {
      ...e,
      v: 8
    };
  }
}), __ = f({
  v: mr()
}), jS = bt({
  latestVersion: 8,
  versionMap: {
    1: La,
    2: i_,
    3: o_,
    4: c_,
    5: p_,
    6: y_,
    7: m_,
    8: g_
  },
  getVersion(e) {
    const t = __.safeParse(e);
    return t.success ? t.data.v : La.schema.safeParse(e).success ? 1 : null;
  }
}), b_ = 8;
function ji(e) {
  return {
    v: b_,
    ...e,
    _ref_id: e._ref_id ? e._ref_id : xi("coll")
  };
}
function S_(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(S_), n = (e.requests ?? []).map(Lg), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = ji({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s
  });
  return e.id && (i.id = e.id), e._ref_id && (i._ref_id = e._ref_id), i;
}
function A_(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(A_), n = (e.requests ?? []).map(a_), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = ji({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s
  });
  return e.id && (i.id = e.id), e._ref_id && (i._ref_id = e._ref_id), i;
}
var Ae = function(e) {
  return function(t) {
    return !e(t);
  };
}, T_ = Lo, $_ = Ho;
function Vi(e, t) {
  return t === void 0 ? function(r) {
    return Vi(e, r);
  } : $_(e, t) ? Qa : Ya(t[e]);
}
var Hi = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, E_ = function(e) {
  return function(t) {
    for (var r = [], n = 0; n < t.length; n++) {
      var a = e(n, t[n]);
      za(a) && r.push(a.value);
    }
    return r;
  };
}, w_ = function(e) {
  return E_(function(t, r) {
    return e(r);
  });
}, Di = function(e) {
  return e.slice();
}, R_ = Vo, qa = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, x_ = function(e) {
  return function(t) {
    return qa(qa([], t, !0), [e], !1);
  };
}, C_ = x_, O_ = function(e) {
  return [e];
}, k_ = C_, I_ = Vi, P_ = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, N_ = function() {
  return {
    concat: function(e, t) {
      return e.concat(t);
    }
  };
}, M_ = function() {
  return {
    concat: N_().concat,
    empty: []
  };
}, kr = Qa, $t = Ya;
function Li(e) {
  return function(t) {
    return e(t) ? $t(t) : kr;
  };
}
var sn = function(e) {
  return function(t) {
    return Ui(t) ? kr : $t(e(t.value));
  };
}, j_ = za, Ui = function(e) {
  return e._tag === "None";
}, V_ = function(e, t) {
  return function(r) {
    return Ui(r) ? e() : t(r.value);
  };
}, H_ = V_, Nn = H_, D_ = function(e, t) {
  for (var r = t(e); r._tag === "Left"; )
    r = t(r.left);
  return r.right;
}, Te = xo, ee = Co, L_ = /* @__PURE__ */ To(2, function(e, t) {
  return Ye(e) ? e : t(e.right);
}), Et = function(e) {
  return function(t) {
    return Ye(t) ? t : ee(e(t.right));
  };
}, Ir = function(e) {
  return function(t) {
    return Ye(t) ? Te(e(t.left)) : t;
  };
}, Ye = wo, U_ = Ro, q_ = function(e) {
  return function(t) {
    return Ye(t) ? e(t.left) : t.right;
  };
}, Mn = q_, Ka = L_, rr = function() {
  return rr = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, rr.apply(this, arguments);
}, wt = function(e, t, r) {
  return ee({
    value: e,
    next: t,
    start: r
  });
}, Rt = function(e, t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = !1), Te({
    input: e,
    expected: t,
    fatal: r
  });
}, K_ = function(e, t) {
  return rr(rr({}, e), { expected: t });
}, B_ = function(e, t) {
  return Z_().concat(e, t);
}, Z_ = function() {
  return {
    concat: function(e, t) {
      return e.input.cursor < t.input.cursor ? Mo().concat(e, t) : e.input.cursor > t.input.cursor ? jr().concat(e, t) : No({
        input: jr(),
        fatal: jr(),
        expected: M_()
      }).concat(e, t);
    }
  };
}, W_ = function(e, t) {
  return t === void 0 && (t = 0), {
    buffer: e,
    cursor: t
  };
}, F_ = function(e) {
  return I_(e.cursor, e.buffer);
}, G_ = function(e) {
  return e.cursor >= e.buffer.length;
}, J_ = function(e) {
  return _(F_(e), sn(function(t) {
    return { value: t, next: { buffer: e.buffer, cursor: e.cursor + 1 } };
  }));
}, Se = function() {
  return Se = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Se.apply(this, arguments);
}, jn = function(e) {
  return function(t) {
    return wt(e, t, t);
  };
}, z_ = function() {
  return function(e) {
    return Rt(e);
  };
}, Q_ = function(e) {
  return function() {
    return Rt(e);
  };
}, H = function(e) {
  return _(eb(Y_()), He(function(t) {
    var r = t[0], n = t[1];
    return e(r) ? Xe(r) : Q_(n);
  }));
}, V = function(e, t) {
  return function(r) {
    return _(e(r), Ir(function(n) {
      return K_(n, [t]);
    }));
  };
}, Y_ = function() {
  return function(e) {
    return _(J_(e), Nn(function() {
      return Rt(e);
    }, function(t) {
      var r = t.value, n = t.next;
      return wt(r, n, e);
    }));
  };
}, X_ = function(e, t) {
  return function(r) {
    return _(e(r), Ka(function(n) {
      return _(t(n.value)(n.next), Ka(function(a) {
        return wt(a.value, a.next, r);
      }));
    }));
  };
}, Pr = function(e, t) {
  return function(r) {
    var n = e(r);
    return U_(n) || n.left.fatal ? n : _(t()(r), Ir(function(a) {
      return B_(n.left, a);
    }));
  };
}, eb = function(e) {
  return function(t) {
    return _(e(t), Et(function(r) {
      return Se(Se({}, r), { value: [r.value, t] });
    }));
  };
}, qi = function(e) {
  return De(function() {
    return Xe(e.empty);
  });
}, Vn = function() {
  return V(function(e) {
    return G_(e) ? wt(void 0, e, e) : Rt(e);
  }, "end of file");
}, tb = function(e) {
  return _(Hn(e), De(function() {
    return Xe([]);
  }));
}, Hn = function(e) {
  return _(e, He(function(t) {
    return Ln(O_(t), function(r) {
      return _(e, j(function(n) {
        return Te(k_(n)(r));
      }), De(function() {
        return Xe(ee(r));
      }));
    });
  }));
}, rb = function(e, t) {
  return function(r) {
    return _(e, He(function() {
      return r;
    }), Un(function() {
      return t;
    }));
  };
}, Ki = function(e) {
  return rb(e, e);
}, nb = function(e) {
  return tb(H(Ae(e)));
}, Dn = function(e, t) {
  return _(t, j(function() {
    return R_;
  }), De(function() {
    return ab(e, t);
  }));
}, ab = function(e, t) {
  return _(e, He(function(r) {
    return Ln(Uo(r), function(n) {
      return _(t, j(function() {
        return ee(n);
      }), De(function() {
        return _(e, j(function(a) {
          return Te(T_(a)(n));
        }));
      }));
    });
  }));
}, xt = function(e, t) {
  return function(r) {
    return _(e(r), Et(function(n) {
      return Se(Se({}, n), { value: t(n.value) });
    }));
  };
}, Bi = function(e, t) {
  return Nr(e, function(r) {
    return xt(t, r);
  });
}, Nr = function(e, t) {
  return X_(e, t);
}, Ln = function(e, t) {
  var r = function(n) {
    return function(a) {
      return Ye(a.value) ? Te({ value: a.value.left, stream: a.next }) : ee(wt(a.value.right, a.next, n));
    };
  };
  return function(n) {
    return D_({ value: e, stream: n }, function(a) {
      var s = t(a.value)(a.stream);
      return Ye(s) ? ee(Rt(a.stream, s.left.expected, s.left.fatal)) : r(n)(s.right);
    });
  };
}, sb = function(e, t) {
  return Pr(e, t);
}, j = function(e) {
  return function(t) {
    return xt(t, e);
  };
}, Xe = jn, He = function(e) {
  return function(t) {
    return Nr(t, e);
  };
}, Un = function(e) {
  return function(t) {
    return Nr(t, function(r) {
      return xt(e(r), function() {
        return r;
      });
    });
  };
}, De = function(e) {
  return function(t) {
    return sb(t, e);
  };
}, ib = "Parser", ob = function(e) {
  return {
    concat: function(t, r) {
      return Bi(xt(t, function(n) {
        return function(a) {
          return e.concat(n, a);
        };
      }), r);
    }
  };
}, cb = function(e) {
  return Se(Se({}, ob(e)), { empty: jn(e.empty) });
}, ub = {
  URI: ib,
  map: xt,
  ap: Bi,
  chain: Nr,
  chainRec: Ln
}, Zi = function(e, t, r) {
  var n;
  return Object.assign({}, e, (n = {}, n[t] = r, n));
}, Wi = function(e) {
  return function(t) {
    return _(t, j(function(r) {
      return Zi({}, e, r);
    }));
  };
}, on = function(e, t) {
  return function(r) {
    return _(r, He(function(n) {
      return _(t(n), j(function(a) {
        return Zi(n, e, a);
      }));
    }));
  };
}, lb = function(e) {
  return jo(e)(e.empty);
}, db = qi(dn), et = function(e) {
  return V(H(function(t) {
    return t === e;
  }), '"'.concat(e, '"'));
}, fb = function(e) {
  return V(H(function(t) {
    return t !== e;
  }), 'anything but "'.concat(e, '"'));
}, qn = function(e) {
  return db(Ct(e));
}, Ct = function(e) {
  return _(Hn(e), j(function(t) {
    return t.join("");
  }));
}, Kn = function(e) {
  return "0123456789".indexOf(e) !== -1;
}, cn = V(H(Kn), "a digit"), hb = /^\s$/, Fi = function(e) {
  return hb.test(e);
}, Gi = V(H(Fi), "a whitespace"), pb = function(e) {
  return e === "_";
}, Ot = function(e) {
  return /[a-z]/.test(e.toLowerCase());
}, Ji = function(e) {
  return Ot(e) || Kn(e) || pb(e);
};
V(H(Ji), "a word character");
V(H(Ot), "a letter");
var yb = function(e) {
  return e.toLowerCase() !== e.toUpperCase();
};
V(H(yb), "an unicode letter");
var zi = function(e) {
  return Ot(e) && e === e.toUpperCase();
};
V(H(zi), "an upper case letter");
var Qi = function(e) {
  return Ot(e) && e === e.toLowerCase();
};
V(H(Qi), "a lower case letter");
V(H(Ae(Kn)), "a non-digit");
var Yi = V(H(Ae(Fi)), "a non-whitespace character");
V(H(Ae(Ji)), "a non-word character");
V(H(Ae(Ot)), "a non-letter character");
V(H(Ae(zi)), "anything but an upper case letter");
V(H(Ae(Qi)), "anything but a lower case letter");
var Xi = function(e) {
  return V(ub.chainRec(e, function(t) {
    return _(gb(0, t), Nn(function() {
      return Xe(ee(e));
    }, function(r) {
      return _(et(r), He(function() {
        return Xe(Te(t.slice(1)));
      }));
    }));
  }), JSON.stringify(e));
}, un = lb(cb(dn)), mt = qi(dn), mb = function(e) {
  return mt(vb(e));
}, vb = function(e) {
  return _(Hn(e), j(function(t) {
    return t.join("");
  }));
}, gb = function(e, t) {
  return e < t.length ? $t(t.charAt(e)) : kr;
}, _b = qn(Gi);
Ct(Gi);
qn(Yi);
Ct(Yi);
var bb = function(e) {
  var t = +e;
  return isNaN(t) || e === "" ? kr : $t(t);
};
V(_(un([mt(et("-")), Ct(cn)]), j(function(e) {
  return +e;
})), "an integer");
V(_(un([mt(et("-")), qn(cn), mt(un([et("."), Ct(cn)]))]), He(function(e) {
  return _(bb(e), Nn(function() {
    return z_();
  }, jn));
})), "a float");
var Sb = Ki(et('"'))(mb(Pr(Xi('\\"'), function() {
  return fb('"');
})));
function eo(e) {
  return function(t) {
    return t(W_(e.split("")));
  };
}
const Ba = (e, t) => (r) => ({
  ...r,
  [e]: t(r[e])
}), Ab = ["#", ":"], tt = Ki(_b), Bn = (e) => (t) => t.join(e), Zn = (e) => _(
  nb((t) => e.includes(t)),
  j(Bn(""))
), Tb = _e(
  Zn,
  Un(() => H(() => !0))
), to = _(
  Sb,
  j((e) => JSON.parse(`"${e}"`))
), $b = _(
  tt(to),
  De(
    () => _(
      Zn([":", `
`]),
      j(Xa)
    )
  )
), Eb = _(
  tt(to),
  De(
    () => _(
      Zn([`
`]),
      j(Xa)
    )
  )
), ro = _(
  mt(Xi("#")),
  j(Ae(es))
), no = _(
  tt(ro),
  Wi("commented"),
  on("key", () => tt($b)),
  Un(() => et(":")),
  on("value", () => Eb)
), wb = _(
  tt(ro),
  Wi("commented"),
  on("key", () => Pr(
    Tb([`
`]),
    () => _(
      Dn(H((e) => !0), Vn()),
      j(_e(
        Di,
        Bn("")
      ))
    )
  )),
  j(_e(
    Li(({ key: e }) => !es(e))
  ))
), Rb = _(
  Dn(tt(no), Vn())
), xb = _(
  Dn(
    Pr(
      _(no, j($t)),
      () => _(
        wb,
        j(_e(
          sn((e) => ({ ...e, value: "" }))
        ))
      )
    ),
    Vn()
  ),
  j(_e(
    w_(_e(
      Li(j_),
      sn((e) => e.value)
    ))
  ))
), Cb = (e) => {
  if (Ab.some((n) => e.includes(n)))
    return !0;
  const t = JSON.stringify(e);
  return t.substring(1, t.length - 1).trim() !== e;
}, Za = (e) => Cb(e) ? JSON.stringify(e) : e, VS = (e) => _(
  e,
  P_(
    _e(
      Ba("key", Za),
      Ba("value", Za),
      ({ key: t, value: r, active: n }) => n ? `${t}: ${r}` : `# ${t}: ${r}`
    )
  ),
  Bn(`
`)
), Ob = (e) => _(
  xb,
  eo(e),
  Ir((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Et(
    ({ value: t }) => _(
      t,
      Hi(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), HS = (e) => _(
  Rb,
  eo(e),
  Ir((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Et(
    ({ value: t }) => _(
      t,
      Hi(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), DS = _e(
  Ob,
  Et(Di),
  Mn(() => [])
), kb = f({
  id: F(c()),
  name: c(),
  variables: R(
    f({
      key: c(),
      value: c()
    })
  )
}), Wa = x({
  initial: !0,
  schema: kb
}), ao = () => Math.random().toString(36).substring(2, 16), so = f({
  v: l(1),
  id: c(),
  name: c(),
  variables: R(
    I([
      f({
        key: c(),
        secret: l(!0)
      }),
      f({
        key: c(),
        value: c(),
        secret: l(!1).catch(!1)
      })
    ])
  )
}), Ib = x({
  initial: !1,
  schema: so,
  up(e) {
    return {
      ...e,
      v: 1,
      id: e.id || ao(),
      variables: e.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), Pb = so.extend({
  v: l(2),
  variables: R(
    f({
      key: c(),
      initialValue: c(),
      currentValue: c(),
      secret: E()
    })
  )
}), Nb = x({
  initial: !1,
  schema: Pb,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a,
          initialValue: a ? "" : r.value,
          currentValue: a ? "" : r.value
        };
      })
    };
  }
}), io = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : r === 14 ? t += "4" : r === 19 ? t += e.charAt(8 + Math.floor(Math.random() * 4)) : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alphanumeric character.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return e.charAt(Math.floor(Math.random() * e.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const e = ["red", "green", "blue", "yellow", "purple", "orange"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "#";
      for (let r = 0; r < 6; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const e = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16)
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16)
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alphanumeric password.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let t = "";
      for (let r = 0; r < 15; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const e = ["ny", "sr", "si"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const e = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const e = ["http", "https"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${e[Math.floor(Math.random() * e.length)]} ${t[Math.floor(Math.random() * t.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const e = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const e = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const e = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const e = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const e = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const e = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const e = ["Supervisor", "Manager", "Coordinator", "Director"];
      return e[Math.floor(Math.random() * e.length)];
    }
  }
  // TODO: Support various other predefined variables
], Mb = f({
  v: mr()
}), LS = bt({
  latestVersion: 2,
  versionMap: {
    0: Wa,
    1: Ib,
    2: Nb
  },
  getVersion(e) {
    const t = Mb.safeParse(e);
    return t.success ? t.data.v : Wa.schema.safeParse(e).success ? 0 : null;
  }
}), nr = /<<([^>]*)>>/g, ar = 10, oo = "ENV_EXPAND_LOOP", Fa = 2;
function jb(e, t) {
  let r = e, n = 0;
  for (; r.match(nr) != null && n <= ar; )
    r = r.replace(nr, (a) => {
      const s = a.replace(/[<>]/g, ""), i = io.find(
        (u) => u.key === s
      );
      if (i)
        return i.getValue();
      const o = t.find((u) => u.key === s);
      return o && "currentValue" in o ? o.currentValue : a;
    }), n++;
  return n > ar ? Te(oo) : ee(r);
}
const US = (e, t) => _(
  jb(e, t),
  Mn(() => e)
);
function Vb(e, t, r = !1, n = !1) {
  if (!t || !e)
    return ee(e);
  let a = e, s = 0, i = !1;
  for (; a.match(nr) != null && s <= ar && !i; )
    a = decodeURI(encodeURI(a)).replace(nr, (o, u) => {
      const d = io.find(
        (A) => A.key === u
      );
      if (d)
        return d.getValue();
      const y = t.find((A) => A && A.key === u);
      return y && "currentValue" in y ? y.secret && n ? (i = !0, `<<${u}>>`) : y.secret && r ? "*".repeat(
        y.currentValue.length
      ) : y.currentValue : "";
    }), s++;
  return s > ar ? Te(oo) : ee(a);
}
const qS = (e, t, r = !1, n = !1) => _(
  Vb(e, t, r, n),
  Mn(() => e)
), Hb = (e) => ({
  key: e.key,
  initialValue: e.initialValue ?? e.value ?? "",
  currentValue: e.currentValue ?? e.value ?? "",
  secret: !1
}), KS = (e) => {
  if (e.v && e.v === Fa) return e;
  const t = e.id || ao(), r = e.name ?? "Untitled", n = (e.variables ?? []).map(Hb);
  return {
    v: Fa,
    id: t,
    name: r,
    variables: n
  };
}, Db = R(
  I([
    f({
      key: c(),
      value: c(),
      secret: l(!1)
    }),
    f({
      key: c(),
      secret: l(!0)
    }),
    f({
      key: c(),
      value: c()
    })
  ])
), Ga = x({
  initial: !0,
  schema: Db
}), co = f({
  v: l(1),
  variables: R(
    I([
      f({
        key: c(),
        secret: l(!0)
      }),
      f({
        key: c(),
        value: c(),
        secret: l(!1)
      })
    ])
  )
}), Lb = x({
  initial: !1,
  schema: co,
  up(e) {
    return {
      v: 1,
      variables: e.map((r) => "value" in r ? {
        key: r.key,
        value: r.value,
        secret: !1
      } : {
        key: r.key,
        secret: !0
      })
    };
  }
}), Ub = co.extend({
  v: l(2),
  variables: R(
    f({
      key: c(),
      initialValue: c(),
      currentValue: c(),
      secret: E()
    })
  )
}), qb = x({
  initial: !1,
  schema: Ub,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => ({
        ...r,
        initialValue: r.secret ? "" : r.value,
        currentValue: r.secret ? "" : r.value,
        value: void 0
      }))
    };
  }
}), Kb = f({
  v: mr()
}), BS = bt({
  latestVersion: 2,
  versionMap: {
    0: Ga,
    1: Lb,
    2: qb
  },
  getVersion(e) {
    const t = Kb.safeParse(e);
    return t.success ? t.data.v : Ga.schema.safeParse(e).success ? 0 : null;
  }
});
async function Bb(e = 6) {
  const t = new Uint8Array(e);
  return crypto.getRandomValues(t), Array.from(t).map((r) => r.toString(16).padStart(2, "0")).join("").substring(0, e);
}
function Zb(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-256", r);
}
function Wb(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-1", r);
}
async function Fb(e, t) {
  return t === "sha256" ? Zb(e) : Wb(e);
}
async function Gb(e, t, r) {
  const n = new TextEncoder(), a = n.encode(e), s = n.encode(t), i = r === "sha256" ? "SHA-256" : "SHA-1", o = await crypto.subtle.importKey(
    "raw",
    a,
    {
      name: "HMAC",
      hash: { name: i }
    },
    !1,
    ["sign"]
  ), u = await crypto.subtle.sign("HMAC", o, s);
  return btoa(String.fromCharCode.apply(null, [...new Uint8Array(u)]));
}
function Ue(e) {
  return e.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
}
async function Jb(e, t) {
  if (!e) return "";
  if (e instanceof FormData)
    if (t === "multipart/form-data") {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" ? r.push(`${a}=${n}`) : r.push(`${a}=${n instanceof File ? n.name : "blob"}`);
      }), Ue(r.join("&"));
    } else {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" && r.push(`${a}=${encodeURIComponent(n)}`);
      }), Ue(r.join("&"));
    }
  if (e instanceof Blob)
    try {
      const r = await e.text();
      return Ue(r);
    } catch (r) {
      return console.error("Failed to read blob content", r), "";
    }
  if (t.includes("application/json") && typeof e == "string")
    try {
      const r = JSON.parse(e);
      return Ue(JSON.stringify(r));
    } catch {
      return Ue(e.toString());
    }
  return Ue(e.toString());
}
async function ZS(e) {
  const t = e.timestamp !== void 0 && e.timestamp !== null ? e.timestamp : Math.floor(Date.now() / 1e3), r = e.nonce && e.nonce !== "" ? e.nonce : await Bb(), n = new URL(e.url), a = n.hostname, s = n.port || (n.protocol === "https:" ? "443" : "80"), i = n.pathname + n.search, o = {
    ts: t,
    nonce: r,
    method: e.method.toUpperCase(),
    resource: i,
    host: a,
    port: s,
    hash: "",
    ext: e.ext || ""
  };
  if (e.includePayloadHash && e.payload)
    try {
      const A = e.contentType || "text/plain", $ = await Jb(e.payload, A), B = `hawk.1.payload
${A}
${$}
`, U = await Fb(B, e.algorithm);
      o.hash = btoa(
        String.fromCharCode.apply(null, [...new Uint8Array(U)])
      );
    } catch (A) {
      console.error("Error calculating payload hash:", A);
    }
  const u = `hawk.1.header
${o.ts}
${o.nonce}
${o.method}
${o.resource}
${o.host}
${o.port}
${o.hash}
${o.ext}
`, d = await Gb(e.key, u, e.algorithm), y = [
    `Hawk id="${e.id}"`,
    `ts="${o.ts}"`,
    `nonce="${o.nonce}"`,
    `mac="${d}"`
  ];
  return e.ext && e.ext !== "" && y.push(`ext="${e.ext}"`), e.app && e.app !== "" && y.push(`app="${e.app}"`), e.dlg && e.dlg !== "" && y.push(`dlg="${e.dlg}"`), o.hash !== "" && y.push(`hash="${o.hash}"`), y.join(", ");
}
async function WS(e) {
  const t = new TextEncoder();
  new TextDecoder();
  const r = e.timestamp || Math.floor(Date.now() / 1e3).toString(), n = e.nonce || crypto.randomUUID(), a = e.host || new URL(e.url).host, s = await crypto.subtle.importKey(
    "raw",
    t.encode(e.clientSecret),
    { name: "HMAC", hash: "SHA-256" },
    !1,
    ["sign"]
  );
  await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(r)
  );
  let i = "";
  if (e.body) {
    const A = await crypto.subtle.digest(
      "SHA-256",
      t.encode(e.body)
    );
    i = Array.from(new Uint8Array(A)).map(($) => $.toString(16).padStart(2, "0")).join("");
  }
  const o = `${e.method} ${e.url} ${a} ${r} ${n} ${i}`, u = await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(o)
  ), d = btoa(
    String.fromCharCode(...new Uint8Array(u))
  );
  return `EG1-HMAC-SHA256 client_token=${e.clientToken};access_token=${e.accessToken};timestamp=${r};nonce=${n};signature=${d}`;
}
const Ze = new TextEncoder(), sr = new TextDecoder();
function zb(...e) {
  const t = e.reduce((a, { length: s }) => a + s, 0), r = new Uint8Array(t);
  let n = 0;
  for (const a of e)
    r.set(a, n), n += a.length;
  return r;
}
function Qb(e) {
  if (Uint8Array.prototype.toBase64)
    return e.toBase64();
  const t = 32768, r = [];
  for (let n = 0; n < e.length; n += t)
    r.push(String.fromCharCode.apply(null, e.subarray(n, n + t)));
  return btoa(r.join(""));
}
function Yb(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(e);
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}
function Xb(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(typeof e == "string" ? e : sr.decode(e), {
      alphabet: "base64url"
    });
  let t = e;
  t instanceof Uint8Array && (t = sr.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return Yb(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}
function Kr(e) {
  let t = e;
  return typeof t == "string" && (t = Ze.encode(t)), Uint8Array.prototype.toBase64 ? t.toBase64({ alphabet: "base64url", omitPadding: !0 }) : Qb(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
class Mr extends Error {
  constructor(r, n) {
    var a;
    super(r, n);
    ne(this, "code", "ERR_JOSE_GENERIC");
    this.name = this.constructor.name, (a = Error.captureStackTrace) == null || a.call(Error, this, this.constructor);
  }
}
ne(Mr, "code", "ERR_JOSE_GENERIC");
class xe extends Mr {
  constructor() {
    super(...arguments);
    ne(this, "code", "ERR_JOSE_NOT_SUPPORTED");
  }
}
ne(xe, "code", "ERR_JOSE_NOT_SUPPORTED");
class Ke extends Mr {
  constructor() {
    super(...arguments);
    ne(this, "code", "ERR_JWS_INVALID");
  }
}
ne(Ke, "code", "ERR_JWS_INVALID");
class uo extends Mr {
  constructor() {
    super(...arguments);
    ne(this, "code", "ERR_JWT_INVALID");
  }
}
ne(uo, "code", "ERR_JWT_INVALID");
function ae(e, t = "algorithm.name") {
  return new TypeError(`CryptoKey does not support this operation, its ${t} must be ${e}`);
}
function lt(e, t) {
  return e.name === t;
}
function Br(e) {
  return parseInt(e.name.slice(4), 10);
}
function eS(e) {
  switch (e) {
    case "ES256":
      return "P-256";
    case "ES384":
      return "P-384";
    case "ES512":
      return "P-521";
    default:
      throw new Error("unreachable");
  }
}
function tS(e, t) {
  if (!e.usages.includes(t))
    throw new TypeError(`CryptoKey does not support this operation, its usages must include ${t}.`);
}
function rS(e, t, r) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!lt(e.algorithm, "HMAC"))
        throw ae("HMAC");
      const n = parseInt(t.slice(2), 10);
      if (Br(e.algorithm.hash) !== n)
        throw ae(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!lt(e.algorithm, "RSASSA-PKCS1-v1_5"))
        throw ae("RSASSA-PKCS1-v1_5");
      const n = parseInt(t.slice(2), 10);
      if (Br(e.algorithm.hash) !== n)
        throw ae(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!lt(e.algorithm, "RSA-PSS"))
        throw ae("RSA-PSS");
      const n = parseInt(t.slice(2), 10);
      if (Br(e.algorithm.hash) !== n)
        throw ae(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "Ed25519":
    case "EdDSA": {
      if (!lt(e.algorithm, "Ed25519"))
        throw ae("Ed25519");
      break;
    }
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!lt(e.algorithm, "ECDSA"))
        throw ae("ECDSA");
      const n = eS(t);
      if (e.algorithm.namedCurve !== n)
        throw ae(n, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  tS(e, r);
}
function lo(e, t, ...r) {
  var n;
  if (r = r.filter(Boolean), r.length > 2) {
    const a = r.pop();
    e += `one of type ${r.join(", ")}, or ${a}.`;
  } else r.length === 2 ? e += `one of type ${r[0]} or ${r[1]}.` : e += `of type ${r[0]}.`;
  return t == null ? e += ` Received ${t}` : typeof t == "function" && t.name ? e += ` Received function ${t.name}` : typeof t == "object" && t != null && (n = t.constructor) != null && n.name && (e += ` Received an instance of ${t.constructor.name}`), e;
}
const nS = (e, ...t) => lo("Key must be ", e, ...t);
function fo(e, t, ...r) {
  return lo(`Key for the ${e} algorithm must be `, t, ...r);
}
function ho(e) {
  return (e == null ? void 0 : e[Symbol.toStringTag]) === "CryptoKey";
}
function po(e) {
  return (e == null ? void 0 : e[Symbol.toStringTag]) === "KeyObject";
}
const yo = (e) => ho(e) || po(e), aS = (...e) => {
  const t = e.filter(Boolean);
  if (t.length === 0 || t.length === 1)
    return !0;
  let r;
  for (const n of t) {
    const a = Object.keys(n);
    if (!r || r.size === 0) {
      r = new Set(a);
      continue;
    }
    for (const s of a) {
      if (r.has(s))
        return !1;
      r.add(s);
    }
  }
  return !0;
};
function sS(e) {
  return typeof e == "object" && e !== null;
}
const mo = (e) => {
  if (!sS(e) || Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}, iS = (e, t) => {
  if (e.startsWith("RS") || e.startsWith("PS")) {
    const { modulusLength: r } = t.algorithm;
    if (typeof r != "number" || r < 2048)
      throw new TypeError(`${e} requires key modulusLength to be 2048 bits or larger`);
  }
};
function oS(e) {
  let t, r;
  switch (e.kty) {
    case "RSA": {
      switch (e.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          t = { name: "RSA-PSS", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          t = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          t = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(e.alg.slice(-3), 10) || 1}`
          }, r = e.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new xe('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "EC": {
      switch (e.alg) {
        case "ES256":
          t = { name: "ECDSA", namedCurve: "P-256" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES384":
          t = { name: "ECDSA", namedCurve: "P-384" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES512":
          t = { name: "ECDSA", namedCurve: "P-521" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: "ECDH", namedCurve: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new xe('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "OKP": {
      switch (e.alg) {
        case "Ed25519":
        case "EdDSA":
          t = { name: "Ed25519" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new xe('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    default:
      throw new xe('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: t, keyUsages: r };
}
const cS = async (e) => {
  if (!e.alg)
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: t, keyUsages: r } = oS(e), n = { ...e };
  return delete n.alg, delete n.use, crypto.subtle.importKey("jwk", n, t, e.ext ?? !e.d, e.key_ops ?? r);
}, uS = (e, t, r, n, a) => {
  if (a.crit !== void 0 && (n == null ? void 0 : n.crit) === void 0)
    throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!n || n.crit === void 0)
    return /* @__PURE__ */ new Set();
  if (!Array.isArray(n.crit) || n.crit.length === 0 || n.crit.some((i) => typeof i != "string" || i.length === 0))
    throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  let s;
  r !== void 0 ? s = new Map([...Object.entries(r), ...t.entries()]) : s = t;
  for (const i of n.crit) {
    if (!s.has(i))
      throw new xe(`Extension Header Parameter "${i}" is not recognized`);
    if (a[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" is missing`);
    if (s.get(i) && n[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" MUST be integrity protected`);
  }
  return new Set(n.crit);
};
function Wn(e) {
  return mo(e) && typeof e.kty == "string";
}
function lS(e) {
  return e.kty !== "oct" && typeof e.d == "string";
}
function dS(e) {
  return e.kty !== "oct" && typeof e.d > "u";
}
function fS(e) {
  return e.kty === "oct" && typeof e.k == "string";
}
let We;
const Ja = async (e, t, r, n = !1) => {
  We || (We = /* @__PURE__ */ new WeakMap());
  let a = We.get(e);
  if (a != null && a[r])
    return a[r];
  const s = await cS({ ...t, alg: r });
  return n && Object.freeze(e), a ? a[r] = s : We.set(e, { [r]: s }), s;
}, hS = (e, t) => {
  var i;
  We || (We = /* @__PURE__ */ new WeakMap());
  let r = We.get(e);
  if (r != null && r[t])
    return r[t];
  const n = e.type === "public", a = !!n;
  let s;
  if (e.asymmetricKeyType === "x25519") {
    switch (t) {
      case "ECDH-ES":
      case "ECDH-ES+A128KW":
      case "ECDH-ES+A192KW":
      case "ECDH-ES+A256KW":
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    s = e.toCryptoKey(e.asymmetricKeyType, a, n ? [] : ["deriveBits"]);
  }
  if (e.asymmetricKeyType === "ed25519") {
    if (t !== "EdDSA" && t !== "Ed25519")
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    s = e.toCryptoKey(e.asymmetricKeyType, a, [
      n ? "verify" : "sign"
    ]);
  }
  if (e.asymmetricKeyType === "rsa") {
    let o;
    switch (t) {
      case "RSA-OAEP":
        o = "SHA-1";
        break;
      case "RS256":
      case "PS256":
      case "RSA-OAEP-256":
        o = "SHA-256";
        break;
      case "RS384":
      case "PS384":
      case "RSA-OAEP-384":
        o = "SHA-384";
        break;
      case "RS512":
      case "PS512":
      case "RSA-OAEP-512":
        o = "SHA-512";
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    if (t.startsWith("RSA-OAEP"))
      return e.toCryptoKey({
        name: "RSA-OAEP",
        hash: o
      }, a, n ? ["encrypt"] : ["decrypt"]);
    s = e.toCryptoKey({
      name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
      hash: o
    }, a, [n ? "verify" : "sign"]);
  }
  if (e.asymmetricKeyType === "ec") {
    const u = (/* @__PURE__ */ new Map([
      ["prime256v1", "P-256"],
      ["secp384r1", "P-384"],
      ["secp521r1", "P-521"]
    ])).get((i = e.asymmetricKeyDetails) == null ? void 0 : i.namedCurve);
    if (!u)
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    t === "ES256" && u === "P-256" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: u
    }, a, [n ? "verify" : "sign"])), t === "ES384" && u === "P-384" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: u
    }, a, [n ? "verify" : "sign"])), t === "ES512" && u === "P-521" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: u
    }, a, [n ? "verify" : "sign"])), t.startsWith("ECDH-ES") && (s = e.toCryptoKey({
      name: "ECDH",
      namedCurve: u
    }, a, n ? [] : ["deriveBits"]));
  }
  if (!s)
    throw new TypeError("given KeyObject instance cannot be used for this algorithm");
  return r ? r[t] = s : We.set(e, { [t]: s }), s;
}, pS = async (e, t) => {
  if (e instanceof Uint8Array || ho(e))
    return e;
  if (po(e)) {
    if (e.type === "secret")
      return e.export();
    if ("toCryptoKey" in e && typeof e.toCryptoKey == "function")
      try {
        return hS(e, t);
      } catch (n) {
        if (n instanceof TypeError)
          throw n;
      }
    let r = e.export({ format: "jwk" });
    return Ja(e, r, t);
  }
  if (Wn(e))
    return e.k ? Xb(e.k) : Ja(e, e, t, !0);
  throw new Error("unreachable");
}, Be = (e) => e == null ? void 0 : e[Symbol.toStringTag], ln = (e, t, r) => {
  var n, a;
  if (t.use !== void 0) {
    let s;
    switch (r) {
      case "sign":
      case "verify":
        s = "sig";
        break;
      case "encrypt":
      case "decrypt":
        s = "enc";
        break;
    }
    if (t.use !== s)
      throw new TypeError(`Invalid key for this operation, its "use" must be "${s}" when present`);
  }
  if (t.alg !== void 0 && t.alg !== e)
    throw new TypeError(`Invalid key for this operation, its "alg" must be "${e}" when present`);
  if (Array.isArray(t.key_ops)) {
    let s;
    switch (!0) {
      case r === "sign":
      case e === "dir":
      case e.includes("CBC-HS"):
        s = r;
        break;
      case e.startsWith("PBES2"):
        s = "deriveBits";
        break;
      case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
        !e.includes("GCM") && e.endsWith("KW") ? s = "unwrapKey" : s = r;
        break;
      case r === "encrypt":
        s = "wrapKey";
        break;
      case r === "decrypt":
        s = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        break;
    }
    if (s && ((a = (n = t.key_ops) == null ? void 0 : n.includes) == null ? void 0 : a.call(n, s)) === !1)
      throw new TypeError(`Invalid key for this operation, its "key_ops" must include "${s}" when present`);
  }
  return !0;
}, yS = (e, t, r) => {
  if (!(t instanceof Uint8Array)) {
    if (Wn(t)) {
      if (fS(t) && ln(e, t, r))
        return;
      throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
    }
    if (!yo(t))
      throw new TypeError(fo(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
    if (t.type !== "secret")
      throw new TypeError(`${Be(t)} instances for symmetric algorithms must be of type "secret"`);
  }
}, mS = (e, t, r) => {
  if (Wn(t))
    switch (r) {
      case "decrypt":
      case "sign":
        if (lS(t) && ln(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a private JWK");
      case "encrypt":
      case "verify":
        if (dS(t) && ln(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a public JWK");
    }
  if (!yo(t))
    throw new TypeError(fo(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
  if (t.type === "secret")
    throw new TypeError(`${Be(t)} instances for asymmetric algorithms must not be of type "secret"`);
  if (t.type === "public")
    switch (r) {
      case "sign":
        throw new TypeError(`${Be(t)} instances for asymmetric algorithm signing must be of type "private"`);
      case "decrypt":
        throw new TypeError(`${Be(t)} instances for asymmetric algorithm decryption must be of type "private"`);
    }
  if (t.type === "private")
    switch (r) {
      case "verify":
        throw new TypeError(`${Be(t)} instances for asymmetric algorithm verifying must be of type "public"`);
      case "encrypt":
        throw new TypeError(`${Be(t)} instances for asymmetric algorithm encryption must be of type "public"`);
    }
}, vS = (e, t, r) => {
  e.startsWith("HS") || e === "dir" || e.startsWith("PBES2") || /^A(?:128|192|256)(?:GCM)?(?:KW)?$/.test(e) || /^A(?:128|192|256)CBC-HS(?:256|384|512)$/.test(e) ? yS(e, t, r) : mS(e, t, r);
}, gS = (e, t) => {
  const r = `SHA-${e.slice(-3)}`;
  switch (e) {
    case "HS256":
    case "HS384":
    case "HS512":
      return { hash: r, name: "HMAC" };
    case "PS256":
    case "PS384":
    case "PS512":
      return { hash: r, name: "RSA-PSS", saltLength: parseInt(e.slice(-3), 10) >> 3 };
    case "RS256":
    case "RS384":
    case "RS512":
      return { hash: r, name: "RSASSA-PKCS1-v1_5" };
    case "ES256":
    case "ES384":
    case "ES512":
      return { hash: r, name: "ECDSA", namedCurve: t.namedCurve };
    case "Ed25519":
    case "EdDSA":
      return { name: "Ed25519" };
    default:
      throw new xe(`alg ${e} is not supported either by JOSE or your javascript runtime`);
  }
}, _S = async (e, t, r) => {
  if (t instanceof Uint8Array) {
    if (!e.startsWith("HS"))
      throw new TypeError(nS(t, "CryptoKey", "KeyObject", "JSON Web Key"));
    return crypto.subtle.importKey("raw", t, { hash: `SHA-${e.slice(-3)}`, name: "HMAC" }, !1, [r]);
  }
  return rS(t, e, r), t;
}, Ee = (e) => Math.floor(e.getTime() / 1e3), vo = 60, go = vo * 60, Fn = go * 24, bS = Fn * 7, SS = Fn * 365.25, AS = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i, Zr = (e) => {
  const t = AS.exec(e);
  if (!t || t[4] && t[1])
    throw new TypeError("Invalid time period format");
  const r = parseFloat(t[2]), n = t[3].toLowerCase();
  let a;
  switch (n) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      a = Math.round(r);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      a = Math.round(r * vo);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      a = Math.round(r * go);
      break;
    case "day":
    case "days":
    case "d":
      a = Math.round(r * Fn);
      break;
    case "week":
    case "weeks":
    case "w":
      a = Math.round(r * bS);
      break;
    default:
      a = Math.round(r * SS);
      break;
  }
  return t[1] === "-" || t[4] === "ago" ? -a : a;
};
function we(e, t) {
  if (!Number.isFinite(t))
    throw new TypeError(`Invalid ${e} input`);
  return t;
}
var P;
class TS {
  constructor(t) {
    pe(this, P);
    if (!mo(t))
      throw new TypeError("JWT Claims Set MUST be an object");
    ye(this, P, structuredClone(t));
  }
  data() {
    return Ze.encode(JSON.stringify(g(this, P)));
  }
  get iss() {
    return g(this, P).iss;
  }
  set iss(t) {
    g(this, P).iss = t;
  }
  get sub() {
    return g(this, P).sub;
  }
  set sub(t) {
    g(this, P).sub = t;
  }
  get aud() {
    return g(this, P).aud;
  }
  set aud(t) {
    g(this, P).aud = t;
  }
  set jti(t) {
    g(this, P).jti = t;
  }
  set nbf(t) {
    typeof t == "number" ? g(this, P).nbf = we("setNotBefore", t) : t instanceof Date ? g(this, P).nbf = we("setNotBefore", Ee(t)) : g(this, P).nbf = Ee(/* @__PURE__ */ new Date()) + Zr(t);
  }
  set exp(t) {
    typeof t == "number" ? g(this, P).exp = we("setExpirationTime", t) : t instanceof Date ? g(this, P).exp = we("setExpirationTime", Ee(t)) : g(this, P).exp = Ee(/* @__PURE__ */ new Date()) + Zr(t);
  }
  set iat(t) {
    typeof t > "u" ? g(this, P).iat = Ee(/* @__PURE__ */ new Date()) : t instanceof Date ? g(this, P).iat = we("setIssuedAt", Ee(t)) : typeof t == "string" ? g(this, P).iat = we("setIssuedAt", Ee(/* @__PURE__ */ new Date()) + Zr(t)) : g(this, P).iat = we("setIssuedAt", t);
  }
}
P = new WeakMap();
const $S = async (e, t, r) => {
  const n = await _S(e, t, "sign");
  iS(e, n);
  const a = await crypto.subtle.sign(gS(e, n.algorithm), n, r);
  return new Uint8Array(a);
};
var vt, W, Q;
class ES {
  constructor(t) {
    pe(this, vt);
    pe(this, W);
    pe(this, Q);
    if (!(t instanceof Uint8Array))
      throw new TypeError("payload must be an instance of Uint8Array");
    ye(this, vt, t);
  }
  setProtectedHeader(t) {
    if (g(this, W))
      throw new TypeError("setProtectedHeader can only be called once");
    return ye(this, W, t), this;
  }
  setUnprotectedHeader(t) {
    if (g(this, Q))
      throw new TypeError("setUnprotectedHeader can only be called once");
    return ye(this, Q, t), this;
  }
  async sign(t, r) {
    if (!g(this, W) && !g(this, Q))
      throw new Ke("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
    if (!aS(g(this, W), g(this, Q)))
      throw new Ke("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const n = {
      ...g(this, W),
      ...g(this, Q)
    }, a = uS(Ke, /* @__PURE__ */ new Map([["b64", !0]]), r == null ? void 0 : r.crit, g(this, W), n);
    let s = !0;
    if (a.has("b64") && (s = g(this, W).b64, typeof s != "boolean"))
      throw new Ke('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const { alg: i } = n;
    if (typeof i != "string" || !i)
      throw new Ke('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    vS(i, t, "sign");
    let o = g(this, vt);
    s && (o = Ze.encode(Kr(o)));
    let u;
    g(this, W) ? u = Ze.encode(Kr(JSON.stringify(g(this, W)))) : u = Ze.encode("");
    const d = zb(u, Ze.encode("."), o), y = await pS(t, i), A = await $S(i, y, d), $ = {
      signature: Kr(A),
      payload: ""
    };
    return s && ($.payload = sr.decode(o)), g(this, Q) && ($.header = g(this, Q)), g(this, W) && ($.protected = sr.decode(u)), $;
  }
}
vt = new WeakMap(), W = new WeakMap(), Q = new WeakMap();
var Fe;
class wS {
  constructor(t) {
    pe(this, Fe);
    ye(this, Fe, new ES(t));
  }
  setProtectedHeader(t) {
    return g(this, Fe).setProtectedHeader(t), this;
  }
  async sign(t, r) {
    const n = await g(this, Fe).sign(t, r);
    if (n.payload === void 0)
      throw new TypeError("use the flattened module for creating JWS with b64: false");
    return `${n.protected}.${n.payload}.${n.signature}`;
  }
}
Fe = new WeakMap();
var ge, J;
class RS {
  constructor(t = {}) {
    pe(this, ge);
    pe(this, J);
    ye(this, J, new TS(t));
  }
  setIssuer(t) {
    return g(this, J).iss = t, this;
  }
  setSubject(t) {
    return g(this, J).sub = t, this;
  }
  setAudience(t) {
    return g(this, J).aud = t, this;
  }
  setJti(t) {
    return g(this, J).jti = t, this;
  }
  setNotBefore(t) {
    return g(this, J).nbf = t, this;
  }
  setExpirationTime(t) {
    return g(this, J).exp = t, this;
  }
  setIssuedAt(t) {
    return g(this, J).iat = t, this;
  }
  setProtectedHeader(t) {
    return ye(this, ge, t), this;
  }
  async sign(t, r) {
    var a;
    const n = new wS(g(this, J).data());
    if (n.setProtectedHeader(g(this, ge)), Array.isArray((a = g(this, ge)) == null ? void 0 : a.crit) && g(this, ge).crit.includes("b64") && g(this, ge).b64 === !1)
      throw new uo("JWTs MUST NOT use unencoded payload");
    return n.sign(t, r);
  }
}
ge = new WeakMap(), J = new WeakMap();
async function FS(e) {
  const {
    algorithm: t,
    secret: r,
    privateKey: n,
    payload: a,
    jwtHeaders: s,
    isSecretBase64Encoded: i
  } = e;
  let o = {}, u = {};
  try {
    const d = (a == null ? void 0 : a.trim()) || "{}";
    d === "" ? o = {} : o = JSON.parse(d);
  } catch (d) {
    return console.error("Failed to parse JWT payload JSON:", d), console.error("Payload value:", a), null;
  }
  try {
    const d = (s == null ? void 0 : s.trim()) || "{}";
    d === "" ? u = {} : u = JSON.parse(d);
  } catch (d) {
    return console.error("Failed to parse JWT headers JSON:", d), console.error("Headers value:", s), null;
  }
  try {
    let d;
    if (t.startsWith("RS") || t.startsWith("ES") || t.startsWith("PS")) {
      if (!n)
        return console.error("Private key is required for RSA/ECDSA algorithms"), null;
      d = new TextEncoder().encode(n);
    } else {
      if (!r)
        return console.error("Secret is required for HMAC algorithms"), null;
      d = i ? Uint8Array.from(Buffer.from(r, "base64")) : new TextEncoder().encode(r);
    }
    return await new RS(o).setProtectedHeader({
      alg: t,
      ...u
    }).sign(d);
  } catch (d) {
    return console.error("Error generating JWT token:", d), null;
  }
}
export {
  Us as AuthCodeGrantTypeParams,
  Ag as ClientCredentialsGrantTypeParams,
  b_ as CollectionSchemaVersion,
  LS as Environment,
  Fa as EnvironmentSchemaVersion,
  ei as FormDataKeyValue,
  yi as GQLHeader,
  bi as GQL_REQ_SCHEMA_VERSION,
  BS as GlobalEnvironment,
  io as HOPP_SUPPORTED_PREDEFINED_VARIABLES,
  jS as HoppCollection,
  Or as HoppGQLAuth,
  Tt as HoppGQLAuthAPIKey,
  In as HoppGQLAuthAWSSignature,
  Me as HoppGQLAuthBasic,
  je as HoppGQLAuthBearer,
  Ve as HoppGQLAuthInherit,
  Ne as HoppGQLAuthNone,
  Rr as HoppGQLAuthOAuth2,
  Pn as HoppGQLRequest,
  xr as HoppRESTAuth,
  Pe as HoppRESTAuthAPIKey,
  ct as HoppRESTAuthAWSSignature,
  ii as HoppRESTAuthAkamaiEdgeGrid,
  de as HoppRESTAuthBasic,
  fe as HoppRESTAuthBearer,
  Tr as HoppRESTAuthDigest,
  si as HoppRESTAuthHAWK,
  he as HoppRESTAuthInherit,
  kg as HoppRESTAuthJWT,
  le as HoppRESTAuthNone,
  Rr as HoppRESTAuthOAuth2,
  At as HoppRESTHeaders,
  Ar as HoppRESTParams,
  Rn as HoppRESTReqBody,
  Cr as HoppRESTRequest,
  Pg as HoppRESTRequestResponse,
  ci as HoppRESTRequestResponses,
  vr as HoppRESTRequestVariables,
  Ig as HoppRESTResponseOriginalRequest,
  St as ImplicitOauthFlowParams,
  zs as PasswordGrantTypeParams,
  ui as RESTReqSchemaVersion,
  OS as RESTResOriginalReqSchemaVersion,
  CS as ValidContentTypesList,
  WS as calculateAkamaiEdgeGridHeader,
  ZS as calculateHawkHeader,
  FS as generateJWTToken,
  xi as generateUniqueRefId,
  n_ as getDefaultGQLRequest,
  Dg as getDefaultRESTRequest,
  kS as isEqualHoppRESTRequest,
  NS as isHoppRESTRequest,
  jg as knownContentTypes,
  ji as makeCollection,
  MS as makeGQLRequest,
  PS as makeRESTRequest,
  US as parseBodyEnvVariables,
  jb as parseBodyEnvVariablesE,
  DS as parseRawKeyValueEntries,
  Ob as parseRawKeyValueEntriesE,
  qS as parseTemplateString,
  Vb as parseTemplateStringE,
  VS as rawKeyValueEntriesToString,
  IS as safelyExtractRESTRequest,
  HS as strictParseRawKeyValueEntriesE,
  a_ as translateToGQLRequest,
  KS as translateToNewEnvironment,
  Hb as translateToNewEnvironmentVariables,
  A_ as translateToNewGQLCollection,
  S_ as translateToNewRESTCollection,
  Lg as translateToNewRequest
};
